import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Observable, Subject, Subscription, catchError, combineLatest, debounceTime, distinctUntilChanged, of, retry, takeUntil } from 'rxjs';
import { EntityService } from 'src/app/services/entity.service';
import { EntityGridService } from 'src/app/services/entity-grid.service';
import { Router } from '@angular/router';
import { Criteria } from 'src/app/services/utility/request-utility.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { AppUtilityService } from 'src/app/services/utility/app.utility.service';
import { LookupStorageService } from 'src/app/services/lookup-storage.service';
import { BroadcastService } from 'src/app/services/excel-communication.service';
import { NetworkService } from 'src/app/services/network.service';
import { SettingsService } from 'src/app/shared/settings/service/settings.service';

declare const Excel: any;
var changeDetectionEventInProgress = false;
var hasChangedRow: boolean = false;
type ValidationFormatBatch = {
  errorStatusRows: Set<number>;
  validStatusRows: Set<number>;
  invalidCellAddresses: Set<string>;
};
@Component({
  selector: 'app-entity',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, NgxMatSelectSearchModule, FormsModule, ReactiveFormsModule, MatProgressSpinnerModule, MatIconModule, MatButtonModule],
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.scss']
})
export class EntityComponent {
  private readonly validationRowBatchSize = 5000;
  private readonly validationExcelWriteBatchSize = 5000;
  private readonly permissionSettingChunkSize = 2000;
  private readonly metadataSettingChunkSize = 8000;
  private readonly validationErrorSettingChunkSize = 8000;
  private sheetPermissionCache = new Map<string, any[]>();
  private entityMetadataCache = new Map<string, any>();
  private validationErrorCache = new Map<string, any>();
  private validationProgress = {
    totalRecords: 0,
    processedRecords: 0,
    batchStatus: 'success',
    retryCount: 0,
    unit: 'rows'
  };
  @ViewChild('searchInput') searchInput!: ElementRef;
  public version = environment.VERSION;
  public entityList: any = [];
  public modelList: any = [];
  public filteredEntityList: any = [];
  public filteredModelList: any = [];
  public loading: boolean = false;
  public pageNumber: number = 0;
  public defaultCodeSetting = "namecode";
  public headers: any;
  public entityId: any;
  public previousEntity: any;
  public currentPage: number = 0;
  public contentName: any = 'Loading Entity List...';
  public currentCriteria!: Criteria;
  public filter: any = [];
  public currentModel: any;
  public previousTableDatas: any;
  public selectedEntity: any;
  public modelId: any;
  public defaultModelId: any;
  public loadEntityData: any = [];
  public message: any;
  public btnTitle: any = 'Show Status';
  public icon_name: any = 'grid_on';
  public editRecords: any = [];
  public deletedRecords: any;
  // public domainAttributeIds: any = [];
  public readColumns: any = [];
  public autoColumns: any = [];
  public validation: boolean = false;
  public subscription$ = new Subject<void>();
  public environment = environment;
  public disablePublishButton: boolean = true;
  public tableName: any;
  public searchInputSubject = new Subject<string>();
  showFilter: boolean = false;
  entity: any;
  query: any;
  public selectedHeaders: any = [];
  public entityMetaData: any;
  public domainAttributesArray: any = [];
  public domainEntity: any;
  public totalElementLimit: any;
  visibleHeaders: any;
  isCodeNull: boolean = false;
  previousQuery: any;
  savedFilter: any = [];
  isUpdate = false;
  public onChangedEventHandler: any;
  public filterApiBatches: number = 0;
  public totalFilterApiBatch: any;
  public intervalId: any;
  public overLay: boolean = false;
  public currentDialog: any;
  private sheetUpdateDialog: any = null;
  private progressDialogCloseError: any = null;
  public updatedData: any;
  public deletionRowRange: any;

  roles: any[] = [];
  sheetLoaded: any = [];
  existingSheets: any = [];
  roleChanged: boolean = false;

  columnRange: string = '';

  private publishWorker: Worker;
  rowCount: any;
  columnCount: any;
  currentSheetHeaders: any;
  public totalSelectedRowForDeletion: number = 0;
  public addedSheetsNames: string[] = [];
  proceed: boolean = true;
  reloadRequired = false;
  networkSubscription: Subscription | null = null;
  insertedRow: any = [];
  showSytsemAttribute = false;
  globalSettings: any;
  publishHasApiErrors: boolean = false;
  publishFailedBatchCount: number = 0;
  publishRetriedBatchCount: number = 0;
  publishRetryAttemptTotal: number = 0;
  publishApiWarningRecordCount: number = 0;
  publishFailedRecordCount: number = 0;
  publishHasNetworkError: boolean = false;
  publishCurrentBatch: number = 0;
  publishTotalBatches: number = 0;
  publishNetworkStatus: string = 'Online';
  publishNetworkCheckIntervalId: any = null;
  publishFailedBatchRecordMap: { [key: number]: number } = {};
  publishUnconfirmedBatchRecordMap: { [key: number]: number } = {};
  publishRetriedBatchMap: { [key: number]: boolean } = {};
  publishStatusLines: string[] = [];
  publishProgress: any = { totalRecords: 0, processedRecords: 0, batchStatus: 'success', retryCount: 0 };
  publishAwaitingAcknowledgement: boolean = false;
  publishVerboseMode: boolean = false;
  publishFinalRecordCount: string | null = null;
  publishFinalProcessingTime: string | null = null;
  publishFinalRetrySummary: string = '';
  publishServerProcessingReadyAt: number | null = null;
  apiResponse: { [key: string]: any[] } = {};
  deletedResponse: { [key: string]: any[] } = {};
  erroBatch: { [key: string]: any[] } = {};
  apiErrorResponse: { [key: string]: any[] } = {};
  constructor(
    private entityService: EntityService,
    private entityGridService: EntityGridService,
    private cd: ChangeDetectorRef,
    private route: Router,
    private indexeddbService: LookupStorageService,
    private appUtilityService: AppUtilityService,
    private broadcastChannelService: BroadcastService,
    private networkService: NetworkService,
    private settingsService: SettingsService
  ) {
    this.addedSheetsNames = [];
    this.publishWorker = new Worker(
      new URL('src/app/web-worker/publish.worker.ts', import.meta.url),
      { type: 'module' }
    );
    this.publishWorker.addEventListener('message', this.publishWorkerMessage.bind(this));

    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/notify`,
      { height: 30, width: 30 },
      (result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          const dialog = result.value;

          dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            (arg: any) => {
              console.log('Message received from dialog:', arg.message);
              if (arg.message === 'close') {
                dialog.close();
              }
            }
          );
        } else {
          console.error('Failed to open dialog:', result.error);
        }
      }
    );

  }

  /**
   * Safe wrapper for Excel.run that catches workbook-focus and other RichApi errors
   * to prevent "Unhandled Promise rejection" in Zone.js.
   */
  private async safeExcelRun(callback: (context: any) => Promise<any>, options?: any): Promise<any> {
    const defaultOptions = { delayForCellEdit: true };
    const mergedOptions = options ? { ...defaultOptions, ...options } : defaultOptions;
    try {
      return await Excel.run(mergedOptions, callback);
    } catch (error: any) {
      changeDetectionEventInProgress = false;
      console.error('Excel.run error:', error?.message || error);
      console.error('Excel.run diagnostic details:', {
        name: error?.name,
        code: error?.code,
        message: error?.message,
        traceMessages: error?.traceMessages,
        debugInfo: error?.debugInfo
      });
      if (error?.message?.includes('cell-editing mode') || error?.message?.includes('edit mode')) {
        // delayForCellEdit should handle this, but log as warning if it still occurs
        console.warn('Excel cell-editing mode error occurred despite delayForCellEdit.');
      } else if (error?.message?.includes('lost focus') || error?.message?.includes('multiple workbooks')) {
        this.message = {
          message: 'Please switch back to this workbook and try again.',
          type: 'error'
        };
        this.cd.detectChanges();
        // this.clearMessage();
      } else if (error?.message?.includes("doesn't exist") || error?.code === 'ItemNotFound') {
        this.message = {
          message: 'The sheet or resource was removed. Please reload the data.',
          type: 'error'
        };
        this.cd.detectChanges();
        this.clearMessage();
      }
      return undefined;
    }
  }

  async ngOnInit() {
    this.proceed = await this.broadcastChannelService.initializeBroadcastChannel();
    if (this.proceed) {
      await this.processSettings();
      this.officeReady();
      const { models } = await this.getAllModels();
      if (models) {
        this.modelList = models;
        this.filteredModelList = models;
        this.defaultModelId = this.filteredModelList[0].id
        if (!!this.defaultModelId) {
          this.handleModelChange(this.defaultModelId)
        }
      }

      // HANDLE THIS FOR FILTER THE ENTITY LIST
      this.searchInputSubject.pipe(
        debounceTime(500), // Adjust debounce time in milliseconds as needed
        distinctUntilChanged()
      ).subscribe((value: any) => {
        this.filteredEntityList = this.entityList.filter((item: any) => {
          return item.displayName
            .trim()
            .toLowerCase()
            .includes(value.trim().toLowerCase());
        });
      });
      this.totalElementLimit = environment.TOTALELEMENTS;
    }
  }

  togglePublishVerboseMode() {
    this.publishVerboseMode = !this.publishVerboseMode;
  }

  async getSettings(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.settingsService.getGlobalSettings().subscribe({
        next: (results) => resolve(results),
        error: (err) => reject(err),
      });
    });
  }

  async processSettings() {
    const results = await this.getSettings();
    if (results?.settingsData) {
      this.showSytsemAttribute = results.settingsData.showSystem;
      this.globalSettings = results;
    } else {
      this.showSytsemAttribute = false;
      this.globalSettings = {
        settingsData: {
          displayFormat: this.defaultCodeSetting,
          showSytem: false,
          timezone: "null",
        },
        type: "global",
      };
    }
  }

  public officeReady() {
    Office.onReady(async (info) => {
      if (info.host === Office.HostType.Excel) {
        await this.safeExcelRun(async (context: any) => {
          const sheets = context.workbook.worksheets;
          const settings = context.workbook.settings;
          sheets.load("items/name, items/visibility");
          const tables = context.workbook.tables;
          tables.load('items/name');
          const previousRole = settings.getItemOrNullObject('roles');
          previousRole.load("value");
          await this.getCurrentTableName();
          const enablePublish = settings.getItemOrNullObject(this.tableName + 'changes');
          enablePublish.load("value");
          const currentMetaData = settings.getItemOrNullObject(this.tableName);
          currentMetaData.load("value");
          await context.sync();
          const data = !currentMetaData.isNullObject
            ? await this.resolveEntityMetadata(context, settings, this.tableName, currentMetaData.value)
            : { tableHeaders: this.headers };
          this.currentSheetHeaders = data.tableHeaders;
          if (tables.items.length > 0) {
            this.addedSheetsNames = tables.items.map((elm: any) => elm.name);
          }
          this.disablePublishButton = enablePublish.isNullObject ? true : enablePublish.value;
          const lookupSheets = await sheets?.items?.filter((el: any) => el?.name?.includes("Lookup_")).map((item: any) => item.name);
          if (lookupSheets?.length > 0) {
            await this.indexeddbService.ensureDbOpen();
            this.addMissingStores(lookupSheets);
          }

          this.sheetLoaded = {};
          tables.items
            .forEach((item: any) => {
              const tableName = item.name;
              if (tableName.includes("Entity_")) {
                this.onChangedEventHandler = item.onChanged.add(this.excelChangeEvent.bind(this));
              }
            })

          const visibleSheets = sheets.items.filter((el: any) => el.visibility === "Visible");
          this.existingSheets = visibleSheets;
          visibleSheets.forEach((item: any) => { this.sheetLoaded[item] = false })
          let token: any = localStorage.getItem('token');
          this.roles = JSON.parse(atob(token.split('.')[1])).realm_access?.roles;
          if (JSON.stringify(this.roles) !== JSON.stringify(previousRole.value) && !previousRole.isNullObject) {
            this.roleChanged = true
          }
          // Handle this event when selecting the rows or change the worksheet
          let entityMetaData: any;
          let permission: any;
          let tableName = "";
          Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, async () => {
            await this.getCurrentTableName();
            if (this.tableName) {
              this.getAllTableBySheet();
              if (tableName !== this.tableName) {
                entityMetaData = settings.getItemOrNullObject(this.tableName);
                entityMetaData.load("value");
                const enablePublish = settings.getItemOrNullObject(this.tableName + 'changes');
                enablePublish.load("value");
                await context.sync();
                this.disablePublishButton = enablePublish.isNullObject ? true : JSON.parse(enablePublish.value);
                const data = !entityMetaData.isNullObject
                  ? await this.resolveEntityMetadata(context, settings, this.tableName, entityMetaData.value)
                  : { tableHeaders: this.headers };
                this.currentSheetHeaders = data.tableHeaders;
                this.autoColumns = data?.autoColumn || [];
                permission = this.currentSheetHeaders?.findIndex((el: any) => ['READ', 'DENY'].includes(el.permission));
                tableName = this.tableName;
                this.showOrHideSystemAtrributes();
              }
              this.cd.detectChanges();
              const selectedRanges = context.workbook.getSelectedRanges();
              selectedRanges.load("areas");
              await context.sync();
              let rowRanges: any = [];
              for (const area of selectedRanges.areas.items) {
                if (area.columnCount >= this.currentSheetHeaders?.length - 6) {
                  const rowRange = this.getRangeDetails(area.address);
                  if (!!rowRange && rowRange !== '') {
                    const cellRange: any = rowRange && rowRange.includes(':') ? rowRange.split(":") : null;
                    const rangeArray = generateRange(+cellRange[0], +cellRange[1]);
                    rowRanges.push(...rangeArray);
                  }
                }
              }
              if (rowRanges.length > 0 && permission === -1) {
                this.deletionRowRange = rowRanges;
              } else {
                this.deletionRowRange = null;
              }
              this.cd.detectChanges();
            }
          });
          await context.sync();
        });
      }
    });
  }


  public getRangeDetails(address: string): string {
    const match = address.match(/(\d+):(\d+)/);
    if (match) {
      return `${match[1]}:${match[2]}`;
    } else {
      // Extract rows and columns from the address
      const rangeParts = address.split("!");
      const range = rangeParts[1]; // E.g., "Sheet1!A1:B2"
      const [start, end] = range.split(":");
      if (start && end) {

        const startRow = start.replace(/[^0-9]/g, ''); // Extract row number from start cell
        const endRow = end.replace(/[^0-9]/g, ''); // Extract row number from end cell

        return `${startRow}:${endRow}`;
      }
      else {
        return ''
      }
    }
  }

  // Handle this function for getting the details from the office settings.
  public async getEntityMetaData() {
    if (!!this.entityId) {
      this.selectedEntity = this.entityList.find((item: any) => item.id === this.entityId);
      this.cd.detectChanges();
      await this.clearExcelCells(false, true, this.selectedEntity);
      this.showFilter = !!this.selectedEntity;
      await this.excelRun()
    }
  }

  // HANDLE THIS FOR GET ALL MODELS
  public getAllModels(): Promise<any> {
    return new Promise((resolve, rejects) => {
      this.entityService.getAllModels().subscribe(
        (models: any) => {
          resolve({
            models,
          });
        },
        (err: any) => {
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          this.loading = false;
          rejects({
            models: [],
          });
        }
      );
    });
  }
  // HANDLE THIS FOR GET THE ENTITY BY MODEL ID
  public handleModelChange(id: any) {
    if (!id) {
      this.entityList = [];
      this.filteredEntityList = [];
      return;
    }
    this.loading = true;
    this.currentModel = this.modelList.find((el: any) => el.id === id);
    this.defaultModelId = this.currentModel?.id;
    this.searchInput?.nativeElement.value ? this.searchInput.nativeElement.value = '' : '';
    const sortType = this.currentModel?.orderType || 'asc';
    this.entityService.getEntityByModelId(id).subscribe(async (res: any) => {
      if (!!res) {
        this.entityList = res.sort((a: any, b: any) => {
          if (sortType === 'asc') {
            return a.displayName.localeCompare(b.displayName); // Ascending order for strings
          } else if (sortType === 'desc') {
            return b.displayName.localeCompare(a.displayName); // Descending order for strings
          } else {
            return a.order - b.order;
          }
        });
        this.filteredEntityList = this.entityList;
        this.cd.detectChanges();
        // this.getEntityFromSheet();
        this.loading = false;
      }
    }, err => {
      if (err.status === 401) {
        localStorage.removeItem('token');
        this.route.navigate(['/landing']);
      }
      this.loading = false;
    })
  }


  async addMissingStores(result: any) {
    for (const item of result) {
      try {
        await this.safeExcelRun(async (context: any) => {
          this.overLay = true;
          let sourceRange = context.workbook.worksheets.getItem(item).getUsedRange();
          sourceRange.load('values');
          await context.sync();
          const values = sourceRange.values;
          const lookupdata: any[] = [];

          for (const row of values) {
            const rowData: any = {
              id: row[1],
              code: row[0],
              name: null,
              key: row[0].toString()
            };

            if (row[0].toString().includes('{') && row[0].toString().includes('}')) {
              rowData.code = row[0].split('{')[0];
              rowData.name = row[0].substring(row[0].indexOf('{') + 1, row[0].indexOf('}'));
              rowData.key = rowData.code.toString();
            }
            lookupdata.push(rowData);
          }

          try {
            await this.indexeddbService.addStore(item, 'key');
          } catch (storeError) {
            console.error('Error creating store:', item, storeError);
            return; // Exit early if store creation fails
          }

          try {
            await this.indexeddbService.addBulkData(item, lookupdata);
          } catch (bulkError) {
            console.error('Error adding bulk data to:', item, bulkError);
            this.overLay = false;
          }
          this.overLay = false;
          this.indexeddbService.closeDb();
        });
      } catch (excelError) {
        this.overLay = false;
        console.error('Error processing Excel data for item:', item, excelError);
      }
    }
  }
  // public domainIdHeaders(headers: any) {
  //   this.domainAttributeIds = [];
  //   headers.forEach((item: any) => {
  //     if (item.formType === 'LOOKUP' && item.totalElements < this.totalElementLimit) {
  //       const value = { name: `${item.selectColumn}_id`, selectColumn: item.selectColumn, formType: 'LOOKUPID', systemAttribute: false, width: 100, id: item?.referencedTableId };
  //       this.domainAttributeIds.push(value);
  //     }
  //   })
  // }


  // HANDLE THIS FUNCTION WHEN SELECT THE ENTITY
  public async entitySelection(entity: any, _criteria?: any, _pageNumber?: number) {
    if (this.entity?.id !== entity.id) {
      let dialog: any;
      let args = 'continue';
      if (this.entity && this.loadEntityData.length != 0) {
        args = 'close';
        Office.context.ui.displayDialogAsync(
          `${environment.URL}/#/confirm`,
          { height: 30, width: 30 },
          (item) => {
            dialog = item.value;
            dialog.addEventHandler(
              Office.EventType.DialogMessageReceived,
              async (arg: any) => {
                // if (arg.message === 'send') {
                //   const data = { message: 'The content of active worksheet will be deleted. Do you want to continue?', yes: 'Yes', no: 'No' }
                //   dialog.messageChild(JSON.stringify(data));
                // } else {
                if (arg?.message === 'send') {
                  setTimeout(() => {
                    const data = { message: 'The content of active worksheet will be deleted. Do you want to continue?', yes: 'Yes', no: 'No' }
                    dialog.messageChild(JSON.stringify(data));
                  }, 800);
                }
                if (arg?.message === 'close') {
                  dialog.close();
                }
                if (arg?.message == 'continue') {
                  dialog.close();
                  this.loadEntity(entity)
                }
              });
          });
      }
      if (args == 'continue') {
        this.loadEntity(entity)
      }
    }
  }

  public async loadEntity(entity: any) {
    await this.currentSheetMetaData(entity);
    this.isCodeNull = false;
    this.message = '';
    this.selectedEntity = entity;
    this.loadEntityData = [];
    this.domainAttributesArray = [];
    this.pageNumber = 0;
    this.subscription$.next();
    this.headers = this.entityGridService.getGridHeaders(
      entity,
      true,
      this.defaultCodeSetting
    );
    this.addHeadersIfNotExists();
    this.rearrangeSystemColumns();
    this.visibleHeaders = [...this.headers];
    this.showFilter = true;
    this.cd.detectChanges();
    const modelName = { modelName: this.currentModel?.displayName };
    entity = { ...entity, ...modelName };
    this.entity = entity;
    this.entityId = entity?.id;
    this.entityService.clearCache();
  }

  public getEntityDataCounts(ids: any[]): Observable<any>[] {
    return ids.map(id =>
      this.entityService.getEntityDataCount(id, 0, 1, []));
  }

  public async openDialogBox(entity: any) {
    this.domainEntity = null;
    this.filterApiBatches = 0;
    this.totalFilterApiBatch = '...';
    // Close any previously open dialog before opening a new one
    if (this.currentDialog) {
      try {
        this.currentDialog.close();
      } catch (e) {
        console.warn('Failed to close previous dialog:', e);
      }
    }
    this.currentDialog = null;
    // let currentSheetEntity = this.entityList.find((elm: any) => elm.id === this.entityId) || null;
    // currentSheetEntity = !!currentSheetEntity && (!!entity && entity?.id === currentSheetEntity?.id) ? currentSheetEntity : entity;
    // let domainBasedIds = this.headers.filter((el: any) => el.formType === 'LOOKUP');
    // if (domainBasedIds.length !== 0) {
    //   const uniqueReferencedTableIds = Array.from(
    //     new Set(domainBasedIds.map((elm: any) => elm.referencedTableId))
    //   );
    //   const data: any = new Promise((resolve) => { combineLatest([...this.getEntityDataCounts(uniqueReferencedTableIds)]).subscribe(res => resolve(res)) });
    //   this.domainEntity = uniqueReferencedTableIds.map((id: any, index: number) => {
    //     return { id: id, count: data.__zone_symbol__value[index] };
    //   });
    // }
    this.pageNumber = 0;
    const token = localStorage.getItem('token');
    const loadedColumns = await this.resolveFilterRestoreColumns(entity);
    const columnQuery = loadedColumns.length
      ? `?c=${encodeURIComponent(loadedColumns.join('|'))}`
      : '';
    Office.context.ui.displayDialogAsync(`${environment.URL}/#/filter/${entity?.groupId}/${entity?.id}/${token}${columnQuery}`, { height: 80, width: 90 },
      (item) => {
        if (item.status !== Office.AsyncResultStatus.Succeeded) {
          // console.error('Failed to open filter dialog:', item.error?.message);
          this.message = { message: 'Failed to open filter dialog. Please try again.', type: 'error' };
          this.cd.detectChanges();
          this.clearMessage();
          return;
        }
        const dialog = item.value;
        this.currentDialog = dialog;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          if (arg?.message === 'send') {
            const data = {
              query: this.query,
              headers: this.selectedHeaders,
              loadedColumns,
              filters: this.filter,
              savedFilter: this.savedFilter,
              isUpdate: this.isUpdate
            }
            dialog.messageChild(JSON.stringify(data));
            return;
          }
          const payload = this.parseOfficeDialogMessage(arg?.message);
          if (payload?.type === 'column-selection') {
            this.selectedHeaders = this.normalizeSelectedColumnNames(payload.selectedColumns);
            return;
          }
          if (arg?.message === 'close' || payload?.type === 'close') {
            this.selectedHeaders = this.normalizeSelectedColumnNames(payload?.selectedColumns ?? this.selectedHeaders);
            this.query = this.previousQuery
            this.isUpdate = false
            dialog.close();
            this.cd.detectChanges();
            await this.saveSelectedColumnsSetting(entity?.id, this.selectedHeaders);
            return;
          }
            // dialog.close();
            let item: any = payload;
            if (!!item?.data) {
              this.domainEntity = item?.data?.domainEntity;
            }
            if ([arg?.message, item?.message].includes('token-expired')) {
              dialog.close();
              localStorage.removeItem('token');
              this.route.navigate(['/landing']);
            }
            if (item?.type === 'invalid-version') {
              dialog.close();
              setTimeout(() => {
                this.handleMismatchVersionDialog(item.message);
              }, 1500);
            }
            if (item?.type === 'progress') {
              this.overLay = true;
              this.intervalId = setInterval(() => {
                dialog.messageChild(JSON.stringify({ currentBatch: this.filterApiBatches, totalBatch: this.totalFilterApiBatch }));
                this.contentName = `Loading batch ${this.filterApiBatches} of ${this.totalFilterApiBatch}`,
                  this.cd.detectChanges();
                if (this.filterApiBatches === this.totalFilterApiBatch) {
                  clearInterval(this.intervalId);
                  this.cd.detectChanges();
                }
              }, 10);
            }
            else {
              this.overLay = false;
              this.cd.detectChanges();
            }
            if (payload?.type === 'progress' || payload?.data?.headers) {
              if (this.loadEntityData.length !== 0) {
                setTimeout(() => {
                  Office.context.ui.displayDialogAsync(
                    `${environment.URL}/#/confirm`,
                    { height: 30, width: 30 },
                    (item) => {
                      const dialog = item.value;
                      dialog.addEventHandler(
                        Office.EventType.DialogMessageReceived,
                        async (args: any) => {
                          if (args.message == 'continue') {
                            this.loading = true;
                            await this.clearExcelCells(false, true, entity);
                            this.loadData(entity, arg)
                          }
                        });
                    });
                }, 1000);
              }
              else {
                this.loading = true;
                await this.clearExcelCells(true, false, entity);
                this.loadData(entity, arg)
              }
            }
        }
        )
      })
  }

  private parseOfficeDialogMessage(message: any): any {
    if (!message || message === 'send' || message === 'close') {
      return null;
    }
    try {
      return JSON.parse(decodeURIComponent(message));
    } catch {
      try {
        return JSON.parse(message);
      } catch {
        return null;
      }
    }
  }

  private normalizeSelectedColumnNames(list: any): string[] {
    if (!Array.isArray(list) || list.length === 0) {
      return [];
    }
    const hasSelectionFlag = list.some((item: any) => item && typeof item === 'object' && typeof item.selected === 'boolean');
    const names = list
      .filter((item: any) => {
        if (!hasSelectionFlag) {
          return true;
        }
        return item?.selected === true;
      })
      .map((item: any) => {
        if (typeof item === 'string') {
          return item.trim();
        }
        return String(item?.name || item?.displayName || item?.selectColumn || '').trim();
      })
      .filter((name: string) => !!name);
    return [...new Set(names)];
  }

  private getEntityAttributeCount(entity: any): number {
    return (entity?.attributes || []).filter((attribute: any) => !attribute?.systemAttribute).length;
  }

  private mapHeaderLabelsToAttributeNames(labels: string[], entity: any): string[] {
    const attributes = (entity?.attributes || []).filter((attribute: any) => !attribute?.systemAttribute);
    const systemLabels = new Set([
      'id', '__row_identifier', 'inputstatus', 'inputmessage', 'validationmessage',
      'validationstatus', 'changedindices', 'input status', 'input message',
      'validation message', 'validation status', 'changed indices'
    ]);
    const names: string[] = [];
    (labels || []).forEach((label: string) => {
      const normalized = String(label || '').trim().toLowerCase();
      if (!normalized || systemLabels.has(normalized)) {
        return;
      }
      const match = attributes.find((attribute: any) => {
        const candidates = [attribute?.name, attribute?.displayName, attribute?.selectColumn]
          .filter(Boolean)
          .map((name: string) => name.toLowerCase());
        return candidates.includes(normalized);
      });
      if (match?.name && !names.includes(match.name)) {
        names.push(match.name);
      }
    });
    return names;
  }

  private async readSelectedColumnsSetting(entityId: any): Promise<string[]> {
    if (!entityId) {
      return [];
    }
    const names = await this.safeExcelRun(async (context: any) => {
      const setting = context.workbook.settings.getItemOrNullObject(`Entity_${entityId}_selectedColumns`);
      setting.load('isNullObject');
      await context.sync();
      if (setting.isNullObject) {
        return [];
      }
      setting.load('value');
      await context.sync();
      try {
        const parsed = JSON.parse(setting.value);
        return this.normalizeSelectedColumnNames(parsed);
      } catch {
        return this.normalizeSelectedColumnNames(String(setting.value || '').split(/[|,]/));
      }
    });
    return Array.isArray(names) ? names : [];
  }

  private async saveSelectedColumnsSetting(entityId: any, names: string[]): Promise<void> {
    if (!entityId) {
      return;
    }
    const selectedNames = this.normalizeSelectedColumnNames(names);
    this.selectedHeaders = selectedNames;
    await this.safeExcelRun(async (context: any) => {
      context.workbook.settings.add(`Entity_${entityId}_selectedColumns`, JSON.stringify(selectedNames));
      await context.sync();
    });
  }

  private async readActiveSheetHeaderLabels(): Promise<string[]> {
    const labels = await this.safeExcelRun(async (context: any) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const tables = sheet.tables;
      tables.load('items');
      await context.sync();
      if (tables.items?.length > 0) {
        const headerRowRange = tables.items[0].getHeaderRowRange();
        headerRowRange.load('values');
        await context.sync();
        return (headerRowRange.values?.[0] || []).map((value: any) => String(value || '').trim()).filter(Boolean);
      }
      const usedRange = sheet.getUsedRangeOrNullObject();
      usedRange.load(['values', 'rowCount', 'isNullObject']);
      await context.sync();
      if (usedRange.isNullObject || !usedRange.rowCount) {
        return [];
      }
      return (usedRange.values?.[0] || []).map((value: any) => String(value || '').trim()).filter(Boolean);
    });
    return Array.isArray(labels) ? labels : [];
  }

  private async resolveFilterRestoreColumns(entity: any): Promise<string[]> {
    const attributeCount = this.getEntityAttributeCount(entity);
    let names = await this.readSelectedColumnsSetting(entity?.id);
    if (!names.length) {
      names = this.normalizeSelectedColumnNames(this.selectedHeaders);
    }
    if (!names.length) {
      const sheetHeaders = await this.readActiveSheetHeaderLabels();
      names = this.mapHeaderLabelsToAttributeNames(sheetHeaders, entity);
    }
    if (!names.length || names.length >= attributeCount) {
      return [];
    }
    const required = (entity?.attributes || [])
      .filter((attribute: any) => {
        const label = String(attribute?.name || '').toLowerCase();
        const display = String(attribute?.displayName || '').toLowerCase();
        return label === 'name' || label === 'code' || display === 'name' || display === 'code';
      })
      .map((attribute: any) => attribute.name);
    return [...new Set([...required, ...names])];
  }


  public async loadData(_entity: any, arg: any) {
    this.reloadRequired = false;
    this.contentName = 'Loading Entity Data...';
    this.loadEntityData = [];
    this.domainAttributesArray = [];
    this.loading = true;
    this.cd.detectChanges();
    const attribute = JSON.parse(decodeURIComponent(arg?.message));
    this.headers = attribute.data.headers;
    this.currentSheetHeaders = attribute?.data?.headers;
    this.selectedHeaders = this.normalizeSelectedColumnNames(attribute.data.selectedAttibutes);
    await this.saveSelectedColumnsSetting(_entity?.id, this.selectedHeaders);
    this.domainAttributesArray = attribute.data.attributeNamesToReplaceCodeWithId?.filter((el: any) => el.count >= this.totalElementLimit);
    this.addHeadersIfNotExists();
    this.rearrangeSystemColumns();
    this.visibleHeaders = [...this.headers];
    this.filter = attribute.data.filters;
    this.query = attribute.data.query;
    this.previousQuery = attribute.data.query;
    await this.getAllDomainApi();
    this.entityService.clearCache();
    if (!this.reloadRequired) {
      this.excelRun();
    }
  }

  public addHeadersIfNotExists(): void {
    const newHeaders = [
      {
        dataType: "number",
        name: "__ROW_IDENTIFIER",
        formType: "FREE_FORM",
        column: "__ROW_IDENTIFIER",
        options: undefined,
        isFilterable: true,
        referencedTableId: null,
        selectColumn: '__ROW_IDENTIFIER',
        systemAttribute: false,
        width: 100,
        autoColumn: true
      },
      {
        dataType: "string",
        column: 'inputstatus',
        name: "Input Status",
        formType: "FREE_FORM",
        options: undefined,
        isFilterable: true,
        referencedTableId: null,
        selectColumn: 'inputstatus',
        systemAttribute: false,
        width: 100,
        autoColumn: true
      },
      {
        dataType: "string",
        column: 'inputmessage',
        name: "Input Message",
        formType: "FREE_FORM",
        options: undefined,
        isFilterable: true,
        referencedTableId: null,
        selectColumn: 'inputmessage',
        systemAttribute: false,
        width: 100,
        autoColumn: true
      },
      {
        dataType: "string",
        name: "Validation Message",
        formType: "FREE_FORM",
        column: "validationmessage",
        options: undefined,
        isFilterable: true,
        referencedTableId: null,
        selectColumn: 'validationmessage',
        systemAttribute: false,
        width: 100,
        autoColumn: true
      },
      {
        column: "validationstatus",
        name: "Validation Status",
        selectColumn: "validationstatus",
        canAutoResize: true,
        autoGenerated: false,
        isSortable: true,
        permission: "UPDATE",
        isFilterable: true,
        dataType: "string",
        isAuto: false,
        width: 100,
        formType: "FREE_FORM",
        dateFormat: "",
        systemAttribute: true,
        referencedTableId: null,
        isLink: false,
        showInForm: false
      },
      {
        dataType: "string",
        name: "Changed Indices",
        formType: "FREE_FORM",
        column: "changedIndices",
        options: undefined,
        isFilterable: true,
        referencedTableId: null,
        selectColumn: 'changedIndices',
        systemAttribute: false,
        width: 100,
        autoColumn: true
      }
    ];
    // Iterate over the new headers
    newHeaders.forEach(newHeader => {
      // Check if a header with the same selectColumn already exists
      const exists = this.headers.some((header: any) => header.selectColumn === newHeader.selectColumn);

      if (!exists) {
        // Add the new header if it doesn't already exist
        this.headers.push(newHeader);
      }
    });
  }

  /**
   * Rearranges system columns (id, validationstatus, validationmessage,
   * inputstatus, inputmessage, changedIndices) to the beginning of this.headers
   * so that they always occupy columns A–F.
   */
  private rearrangeSystemColumns(): void {
    const validationStatusIndex = this.headers.findIndex((item: any) => item.column === 'validationstatus');
    const idIndex = this.headers.findIndex((item: any) => item.column === 'id');
    const inputStatusIndex = this.headers.findIndex((item: any) => item.column === 'inputstatus');
    const validationMessageIndex = this.headers.findIndex((item: any) => item.column === 'validationmessage');
    const inputMessageIndex = this.headers.findIndex((item: any) => item.column === 'inputmessage');
    const changedIndex = this.headers.findIndex((item: any) => item.column === 'changedIndices');

    if (validationStatusIndex !== -1 && idIndex !== -1 && inputStatusIndex !== -1) {
      const validationStatusItem = this.headers.splice(validationStatusIndex, 1)[0];
      const idItem = this.headers.splice(idIndex - (idIndex > validationStatusIndex ? 1 : 0), 1)[0];
      const inputStatusItem = this.headers.splice(inputStatusIndex - (inputStatusIndex > validationStatusIndex ? 1 : 0) - (inputStatusIndex > idIndex ? 1 : 0), 1)[0];
      const validationMessageItem = this.headers.splice(validationMessageIndex - (validationMessageIndex > validationStatusIndex ? 1 : 0) - (validationMessageIndex > idIndex ? 1 : 0) - (validationMessageIndex > inputStatusIndex ? 1 : 0), 1)[0];
      const inputMessageItem = this.headers.splice(inputMessageIndex - (inputMessageIndex > validationStatusIndex ? 1 : 0) - (inputMessageIndex > idIndex ? 1 : 0) - (inputMessageIndex > inputStatusIndex ? 1 : 0) - (inputMessageIndex > validationMessageIndex ? 1 : 0), 1)[0];
      const changedItem = this.headers.splice(changedIndex - (changedIndex > validationStatusIndex ? 1 : 0) - (changedIndex > idIndex ? 1 : 0) - (changedIndex > inputStatusIndex ? 1 : 0) - (changedIndex > validationMessageIndex ? 1 : 0) - (changedIndex > inputMessageIndex ? 1 : 0), 1)[0];
      this.headers.unshift(idItem, validationStatusItem, validationMessageItem, inputStatusItem, inputMessageItem, changedItem);
    }
  }

  public loadDataByEntityId(_entity: any, criteria: any): Promise<any> {
    return new Promise((resolve) => {
      this.entityService.getEntitesByIds(this.selectedEntity.id, criteria).pipe(
        takeUntil(this.subscription$),
        retry(1), // Retry the request up to 3 times before failing
        catchError((err) => {
          console.log(err);
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          if (err?.error?.errorCode === "VEX-400") {
            this.currentDialog.close();
            setTimeout(() => {
              this.handleMismatchVersionDialog(err?.error?.message);
            }, 500);
          }
          this.loading = false;
          this.overLay = false
          return of({ entityData: [] }); // Return an empty entityData array in case of an error
        })
      ).subscribe(
        (entityData: any) => {
          resolve({
            entityData,
          });
        },
        (err: any) => {
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          // this.loading = false;
          resolve({
            entityData: [],
          });
        }
      );
    });
  }

  public formatingTableRowData(data: any, startRowIndex: any) {
    return data.map((el: any, index: number) => {
      if (['FALSE', false].includes(el.validationstatus)) {
        el = { ...el, validationstatus: 'Validation Failed' };
      } else if (['isValid', 'TRUE', true, 'nan', null].includes(el.validationstatus) || el.is_valid) {
        el = { ...el, validationstatus: 'Validation Succeeded' };
      }
      if (['READ', 'DENY'].includes(el.permission)) {
        this.readColumns.push(index + startRowIndex);
      }
      return this.headers.map((header: any) => {
        if (header.dataType == 'date' && !!el[header.column]) {
          el[header.column] = moment(el[header.column]).parseZone().format("MM/DD/YYYY")
        }

        if (header.selectColumn === '__ROW_IDENTIFIER') {
          return '=ROW()';
        }
        if (header.selectColumn === 'inputstatus') {
          const inputStatus = ['', null, undefined].includes(el?.validationstatus) ? 'Error' : ['DENY', 'READ'].includes(el?.permission) ? 'Read Only' : 'Unchanged';
          return inputStatus;
        }
        if (header.formType === "LOOKUP") {
          // const val: any = { columnLetter: columnLetter, name: header.selectColumn };
          // domainAttributeIndex.push(val);
          const name = el[`${header.selectColumn}_name`];
          const code = el[`${header.selectColumn}_code`];
          const value = header.totalElements > this.totalElementLimit ? code : !!name && !!code ? `${code}{${name}}` : !name && code ? `${code}` : name;
          return value
        }
        // else if (header.formType === "LOOKUPID") {
        //   const letterIndex = index + 2;
        //   const attIndex = domainAttributeIndex.find((el: any) => el.name === header.selectColumn);
        //   const value = `=IFERROR(INDEX(Lookup_${header.id}!B:B, MATCH(${attIndex?.columnLetter}${letterIndex}, Lookup_${header.id}!A:A, 0)), "")`;
        //   return value
        // }
        else {
          return el[header?.selectColumn]
        }
      });
    });
  }

  public async refreshEntityRecords() {
    this.reloadRequired = false;
    if (this.roleChanged && !this.sheetLoaded[this.entity?.displayName.trim().replace(/\s+/g, "")] && this.existingSheets.includes(this.entity?.displayName)) {
      this.checkSheetPermission()
    }
    else {
      this.apiResponse[this.selectedEntity.id] = [];
      this.deletedResponse[this.selectedEntity.id] = [];
      this.erroBatch[this.selectedEntity.id] = [];
      this.apiErrorResponse[this.selectedEntity.id] = [];
      this.loading = true;
      this.overLay = true;
      this.icon_name = 'grid_on';
      this.btnTitle = 'Show Status';
      this.contentName = 'Loading domain-based attributes...';
      this.totalFilterApiBatch = '...';
      this.filterApiBatches = 0;
      this.loadEntityData = [];
      this.domainAttributesArray = [];
      this.pageNumber = 0;
      this.cd.detectChanges();
      this.openDialogWithFallback('/#/loader', { height: 50, width: 60 }, (dialog: any) => {
        this.currentDialog = dialog;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          if (arg?.message === 'start') {
            this.intervalId = setInterval(() => {
              dialog.messageChild(JSON.stringify(this.contentName));
              this.cd.detectChanges();
            }, 10);
          }
        })
      });
      this.entityService.clearCache();
      await this.getAllDomainApi();
      this.entityService.clearCache();
      await this.getEntityMetaData();
    }
  }

  public async refreshExcelData(_entity: any) {
    if (hasChangedRow) {
      Office.context.ui.displayDialogAsync(
        `${environment.URL}/#/confirm`,
        { height: 30, width: 40 },
        (item) => {
          const dialog = item.value;
          dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            async (arg: any) => {
              // if (arg.message === 'send') {
              //   const data = { message: 'The content of active worksheet will be deleted. Do you want to continue?', yes: 'Yes', no: 'No' }
              //   dialog.messageChild(JSON.stringify(data));
              // } else {
              if (arg?.message === 'send') {
                setTimeout(() => {
                  const data = { message: 'Some changes have not been published. If you continue, all unpublished changes will be lost. Do you want to continue?', yes: 'Yes', no: 'No' }
                  dialog.messageChild(JSON.stringify(data));
                }, 800);
              }
              if (arg?.message == 'close') {
                dialog.close();
              }
              if (arg?.message == 'continue') {
                dialog.close();
                hasChangedRow = false;
                setTimeout(() => {
                  this.refreshEntityRecords();
                }, 500);
              }
            });
        });
    }
    else {
      this.refreshEntityRecords();
    }
  }

  public async publish() {
    if (this.roleChanged && !this.sheetLoaded[this.entity?.displayName.trim().replace(/\s+/g, "")] && this.existingSheets.includes(this.entity?.displayName)) {
      this.checkSheetPermission()
    }
    else {
      this.safeExcelRun(async (context: any) => {
        const sheet = context.workbook.worksheets.getActiveWorksheet();
        const table = sheet.tables.getItem(this.tableName);
        const headerRowRange = table.getHeaderRowRange();
        const settings = context.workbook.settings;
        const entityMetaData = settings.getItem(this.tableName);
        entityMetaData.load("value");
        headerRowRange.load("values");
        await context.sync();
        const data = await this.resolveEntityMetadata(context, settings, this.tableName, entityMetaData.value);
        const codeColumn = data?.tableHeaders?.find((el: any) => el.column === 'code');
        if (!headerRowRange.values[0].includes(codeColumn?.name)) {
          Office.context.ui.displayDialogAsync(
            `${environment.URL}/#/missing/column`, { height: 30, width: 30 },
            (asyncResult: any) => {
              const dialog = asyncResult.value;
              dialog.addEventHandler(Office.EventType.DialogMessageReceived, () => {
                // if (arg.message === 'send') {
                //   const data = { message: "Critical columns missing : 'Code'. Detaching from worksheet", yes: 'Close' }
                //   dialog.messageChild(JSON.stringify(data));
                // } else {
                dialog.close();
                // }
              })
            }
          );
        }
        else {
          this.publishAwaitingAcknowledgement = false;
          this.publishProgress = { totalRecords: 0, processedRecords: 0, batchStatus: 'success', retryCount: 0 };
          this.publishStatusLines = [];
          this.publishNetworkStatus = 'Online';
          this.publishFinalRecordCount = null;
          this.publishFinalProcessingTime = null;
          this.publishFinalRetrySummary = '';
          this.publishServerProcessingReadyAt = null;
          this.message = '';
          this.contentName = 'Preparing publish...';

          this.openDialogWithFallback('/#/loader', { height: 50, width: 60 }, (dialog: any) => {
            this.currentDialog = dialog;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
              if (arg?.message === 'start') {
                this.intervalId = setInterval(() => {
                  const loaderPayload = {
                    action: 'publish',
                    message: this.contentName,
                    progress: this.publishProgress,
                    networkOnline: this.publishNetworkStatus === 'Online',
                    requireAcknowledgement: this.publishAwaitingAcknowledgement,
                    finalMessage: this.message?.message || '',
                    finalRecordCount: this.publishFinalRecordCount,
                    finalProcessingTime: this.publishFinalProcessingTime,
                    finalRetrySummary: this.publishFinalRetrySummary
                  };
                  dialog.messageChild(JSON.stringify(loaderPayload));
                  this.cd.detectChanges();
                }, 10);
                this.entityId = data?.entity_id
                this.selectedEntity = data?.selectedEntity;
                this.domainAttributesArray = data?.attributeNamesToReplaceCodeWithId;
                this.headers = data?.tableHeaders;
                this.readColumns = data?.readColumns;
                this.autoColumns = data?.autoColumns;
                this.publishRecords()
              }
              if (arg?.message === 'acknowledge') {
                this.publishAwaitingAcknowledgement = false;
                this.message = '';
                if (!!this.currentDialog) {
                  this.currentDialog.close();
                }
                if (!!this.intervalId) {
                  clearInterval(this.intervalId);
                }
                this.contentName = '';
                this.cd.detectChanges();
              }
            })
          });
        }
        return context.sync();
      })
    }
  }




  private async downloadEntityPages(criteria?: any): Promise<any[]> {
    const pages: any[] = [];
    let lastId: any;
    for (let currentPage = 0, totalPages = 1; currentPage < totalPages; currentPage++) {
      if (this.reloadRequired) break;
      const pageCriteria = criteria || {
        filters: this.filter,
        sorters: [{ direction: "ASC", property: "id" }],
        pager: {
          pageNumber: currentPage,
          pageSize: environment.PAGESIZE,
          ...(currentPage !== 0 ? { overRideOffset: true, greaterThan: true, id: lastId } : {})
        }
      };
      const { entityData } = await this.loadDataByEntityId(this.selectedEntity, pageCriteria);
      pages.push(entityData);
      const items = entityData?.content || [];
      totalPages = entityData?.totalPages || 1;
      this.filterApiBatches = currentPage + 1;
      this.totalFilterApiBatch = totalPages;
      this.contentName = `Loading batch ${this.filterApiBatches} of ${this.totalFilterApiBatch}`;
      this.cd.detectChanges();
      if (items.length) lastId = items[items.length - 1]?.id || null;
    }
    return pages;
  }

  private async confirmDownloadedData(recordCount: number): Promise<boolean> {
    const readyMessage = `${recordCount.toLocaleString()} records are ready. Click Load to update the worksheet.`;
    this.contentName = readyMessage;
    this.cd.detectChanges();
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.currentDialog) {
      this.currentDialog.close();
      this.currentDialog = null;
      await new Promise(resolve => setTimeout(resolve, 400));
    }
    return new Promise<boolean>((resolve) => {
      Office.context.ui.displayDialogAsync(
        `${environment.URL}/#/confirm`,
        { height: 35, width: 45 },
        (result: any) => {
          if (result.status !== Office.AsyncResultStatus.Succeeded) {
            resolve(false);
            return;
          }
          const dialog = result.value;
          this.currentDialog = dialog;
          let completed = false;
          const finish = (confirmed: boolean) => {
            if (completed) return;
            completed = true;
            dialog.close();
            this.currentDialog = null;
            resolve(confirmed);
          };
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
            if (arg?.message === 'send') {
              dialog.messageChild(JSON.stringify({
                message: readyMessage,
                yes: 'Load',
                no: 'Cancel',
                note: 'Please do not close this dialog box until the operation is completed and do not switch workbooks.'
              }));
            } else if (arg?.message === 'continue') {
              finish(true);
            } else if (arg?.message === 'close') {
              finish(false);
            }
          });
          dialog.addEventHandler(Office.EventType.DialogEventReceived, () => finish(false));
        }
      );
    });
  }

  private applyReadOnlyRowFormatting(sheet: any): void {
    const dataColumnCount = Math.max(0, this.headers.length - 1);
    if (dataColumnCount === 0) return;

    const lastColumnLetter = ExcelHelper.getColumnLetter(dataColumnCount - 1);
    const readOnlyRows = Array.from(new Set(
      this.readColumns.filter((row: any) => typeof row === 'number') as number[]
    )).sort((left: number, right: number) => left - right);

    const rangeAreaSize = 250;
    for (let index = 0; index < readOnlyRows.length; index += rangeAreaSize) {
      const addresses = readOnlyRows
        .slice(index, index + rangeAreaSize)
        .map((rowIndex: number) => `A${rowIndex + 1}:${lastColumnLetter}${rowIndex + 1}`);
      sheet.getRanges(addresses.join(',')).format.fill.color = "#c5c5c5";
    }
  }

  private async openSheetUpdateDialog(recordCount: number): Promise<boolean> {
    this.progressDialogCloseError = null;
    if (this.sheetUpdateDialog) {
      try { this.sheetUpdateDialog.close(); } catch { }
      this.sheetUpdateDialog = null;
    }
    // Closing an Office dialog is asynchronous. Retry until Office confirms that
    // the dedicated progress dialog has actually opened.
    for (let attempt = 1; attempt <= 20; attempt++) {
      const dialog = await new Promise<any>((resolve) => {
        Office.context.ui.displayDialogAsync(
          `${environment.URL}/#/loader`,
          { height: 90, width: 90, displayInIframe: true },
          (result: any) => {
            if (result.status === Office.AsyncResultStatus.Succeeded) {
              resolve(result.value);
            } else {
              console.warn(`Worksheet progress dialog open attempt ${attempt} failed:`, result.error);
              resolve(null);
            }
          }
        );
      });

      if (dialog) {
        this.sheetUpdateDialog = dialog;
        const dialogReady = await new Promise<boolean>((resolve) => {
          let ready = false;
          const timeoutId = setTimeout(() => resolve(false), 10000);
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
            if (arg?.message === 'start') {
              dialog.messageChild(JSON.stringify({
                message: `Updating worksheet: 0 of ${recordCount.toLocaleString()} rows (0%)`,
                statusOnly: true,
                note: 'Please do not close this dialog box until the operation is completed and do not switch workbooks.'
              }));
              if (!ready) {
                ready = true;
                clearTimeout(timeoutId);
                resolve(true);
              }
            }
          });
          dialog.addEventHandler(Office.EventType.DialogEventReceived, (event: any) => {
            console.warn('Worksheet progress dialog closed:', event?.error);
            this.progressDialogCloseError = event?.error;
            if (this.sheetUpdateDialog === dialog) {
              this.sheetUpdateDialog = null;
            }
            if (!ready) {
              clearTimeout(timeoutId);
              resolve(false);
            }
          });
        });
        if (dialogReady) {
          return true;
        }
        try { dialog.close(); } catch { }
        if (this.sheetUpdateDialog === dialog) {
          this.sheetUpdateDialog = null;
        }
      }

      await new Promise(resolve => setTimeout(resolve, 100));
    }
    return false;
  }

  private async waitForWorkbookReady(): Promise<boolean> {
    while (true) {
      try {
        await Excel.run({ delayForCellEdit: true }, async (context: any) => {
          const sheet = context.workbook.worksheets.getActiveWorksheet();
          sheet.load('name');
          await context.sync();
        });
        return true;
      } catch (error: any) {
        console.info('Original workbook focus was lost:', error?.message || error);
        const retry = await this.confirmWorkbookFocusRetry();
        if (!retry) {
          return false;
        }
      }
    }
  }

  private async confirmWorkbookFocusRetry(): Promise<boolean> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return new Promise<boolean>((resolve) => {
      Office.context.ui.displayDialogAsync(
        `${environment.URL}/#/confirm`,
        { height: 35, width: 45 },
        (result: any) => {
          if (result.status !== Office.AsyncResultStatus.Succeeded) {
            resolve(false);
            return;
          }
          const dialog = result.value;
          let completed = false;
          const finish = (retry: boolean) => {
            if (completed) return;
            completed = true;
            dialog.close();
            resolve(retry);
          };
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg: any) => {
            if (arg?.message === 'send') {
              dialog.messageChild(JSON.stringify({
                message: 'Workbook focus was lost. Return to the original workbook, then click Retry.',
                yes: 'Retry',
                no: 'Cancel'
              }));
            } else if (arg?.message === 'continue') {
              finish(true);
            } else if (arg?.message === 'close') {
              finish(false);
            }
          });
          dialog.addEventHandler(Office.EventType.DialogEventReceived, () => finish(false));
        }
      );
    });
  }

  // Handle this function to add the data in excel sheet
  public async excelRun(data?: any, criteria?: any) {
    const loadDiagnosticId = `${this.selectedEntity?.id || 'unknown'}-${Date.now()}`;
    const loadStartedAt = Date.now();
    let excelLoadSucceeded = false;
    let writtenRows = 0;
    console.info(`[Excel load ${loadDiagnosticId}] Started`, {
      entityId: this.selectedEntity?.id,
      entityName: this.selectedEntity?.displayName,
      headerCount: this.headers?.length,
      pageSize: environment.PAGESIZE,
      isRefresh: !!data
    });

    const downloadedPages = await this.downloadEntityPages(criteria);
    const recordCount = downloadedPages.reduce(
      (total: number, page: any) => total + (page?.content?.length || 0), 0
    );
    const confirmed = await this.confirmDownloadedData(recordCount);
    if (!confirmed || this.reloadRequired) {
      this.loading = false;
      this.overLay = false;
      this.cd.detectChanges();
      return;
    }
    this.contentName = 'Waiting for the original workbook...';
    this.cd.detectChanges();
    const workbookReady = await this.waitForWorkbookReady();
    if (!workbookReady) {
      this.loading = false;
      this.overLay = false;
      this.message = {
        message: 'The original workbook did not regain focus. Return to it and try loading again.',
        type: 'error'
      };
      this.cd.detectChanges();
      return;
    }
    const progressDialogOpened = await this.openSheetUpdateDialog(recordCount);
    if (!progressDialogOpened) {
      this.loading = false;
      this.overLay = false;
      this.message = {
        message: 'The worksheet progress dialog could not be opened. No data was written. Please try again.',
        type: 'error'
      };
      this.cd.detectChanges();
      return;
    }

    await Excel.run({ delayForCellEdit: true }, async (context: any) => {
      // A reload can still have the previous table's handler alive until its sheet
      // is removed. Suppress Excel events for the entire programmatic write so
      // those writes are never interpreted as user edits.
      changeDetectionEventInProgress = true;
      context.runtime.enableEvents = false;
      await context.sync();
      await this.addPublishStatus(context, true);
      let currentSheetData: any = [];
      // Get the active worksheet
      const targetSheetName = this.handleSheetName(this.selectedEntity?.displayName);
      const sheet = context.workbook.worksheets.getItem(targetSheetName);
      // initial column data validation
      await this.addPreHeaderDataValidation(sheet, this.headers, context);

      const columnCount = this.headers.length;
      let headerRange = sheet.getRangeByIndexes(0, 0, 1, columnCount);
      // let range = sheet.getRangeByIndexes(0, 0, rowCount - (rowCount - 1), columnCount);
      // Freeze the headers
      sheet.freezePanes.freezeRows(1);

      // Set headers dynamically
      const headers = this.headers.map((header: any) => header.name);
      headerRange.values = [headers];
      console.info(`[Excel load ${loadDiagnosticId}] Header write queued`, {
        headerCount: headers.length,
        firstHeader: headers[0],
        lastHeader: headers[headers.length - 1]
      });

      const rowsPerWrite = 10000;
      const allItems: any[] = downloadedPages.reduce(
        (items: any[], page: any) => items.concat(page?.content || []), []
      );
      const totalWriteBatches = Math.ceil(allItems.length / rowsPerWrite);

      for (let batchIndex = 0; batchIndex < totalWriteBatches; batchIndex++) {
        if (this.reloadRequired == true) {
          break;
        }
        if (!this.sheetUpdateDialog) {
          throw new Error(`The worksheet progress dialog closed before the operation completed. Office event: ${this.progressDialogCloseError ?? 'unknown'}.`);
        }
        const item = allItems.slice(batchIndex * rowsPerWrite, (batchIndex + 1) * rowsPerWrite);
        if (item.length > 0) {
          this.filterApiBatches = batchIndex + 1;
          this.totalFilterApiBatch = totalWriteBatches;
          this.contentName = `Preparing worksheet batch ${this.filterApiBatches} of ${this.totalFilterApiBatch}`;
          if (this.sheetUpdateDialog) {
            this.sheetUpdateDialog.messageChild(JSON.stringify({
              message: this.contentName,
              statusOnly: true,
              note: 'Please do not close this dialog box until the operation is completed and do not switch workbooks.'
            }));
          }

          const startRowIndex = currentSheetData.length + 1;
          currentSheetData.push(...item);

          // Update the table with formatted data
          const tableData = await this.formatingTableRowData(item, startRowIndex);
          this.cd.detectChanges();
          if (tableData.length > 0) {
            const columnCount = this.headers.length;
            context.application.suspendScreenUpdatingUntilNextSync();
            const tableRange = sheet.getRangeByIndexes(
              startRowIndex,
              0,
              tableData.length,
              columnCount
            );
            tableRange.values = tableData;
            await context.sync();
            writtenRows += tableData.length;
            if (!this.sheetUpdateDialog) {
              throw new Error(`The worksheet progress dialog closed before the operation completed. Office event: ${this.progressDialogCloseError ?? 'unknown'}.`);
            }
            const percentage = recordCount > 0
              ? Math.min(100, Math.round((writtenRows / recordCount) * 100))
              : 100;
            this.contentName = `Updating worksheet: ${writtenRows.toLocaleString()} of ${recordCount.toLocaleString()} rows (${percentage}%)`;
            if (this.sheetUpdateDialog) {
              this.sheetUpdateDialog.messageChild(JSON.stringify({
                message: this.contentName,
                statusOnly: true,
                note: 'Please do not close this dialog box until the operation is completed and do not switch workbooks.'
              }));
            }
            this.cd.detectChanges();
            console.info(`[Excel load ${loadDiagnosticId}] Data batch queued`, {
              batch: batchIndex + 1,
              totalBatches: totalWriteBatches,
              startRowIndex,
              rowCount: tableData.length,
              columnCount,
              queuedRows: currentSheetData.length,
              currentHeaderCount: this.headers.length
            });
          } else {
            console.log("No data available to update the table.");
          }
        } else {
          console.log("No records found in this batch.");
          await this.manageRowIdentifierRow(sheet);
          this.loading = false;
          this.overLay = false;
          this.cd.detectChanges();
        }
      }


      // If a reload was triggered during data loading, stop here — the sheet may have been replaced
      if (this.reloadRequired) {
        this.loading = false;
        this.overLay = false;
        this.cd.detectChanges();
        return;
      }

      // await context.sync();
      console.info(`[Excel load ${loadDiagnosticId}] Synchronizing queued header and data writes`, {
        rowCount: currentSheetData.length,
        headerCount: this.headers.length
      });
      this.applyReadOnlyRowFormatting(sheet);
      await context.sync();
      console.info(`[Excel load ${loadDiagnosticId}] Header and data synchronization completed`, {
        elapsedMs: Date.now() - loadStartedAt
      });

      const startRow = 0;
      const startColumn = 0;
      const rowCount = currentSheetData.length + 1;
      const columnCounts = this.headers.length;

      // Get the range of the data to be converted to a table
      const dataRange = sheet.getRangeByIndexes(startRow, startColumn, rowCount, columnCounts);

      if (!this.sheetUpdateDialog) {
        throw new Error(`The worksheet progress dialog closed before the operation completed. Office event: ${this.progressDialogCloseError ?? 'unknown'}.`);
      }
      // Convert the range to a table
      const table = sheet.tables.add(dataRange, true /* hasHeaders */);
      this.contentName = 'Applying table formatting and validations...';
      if (this.sheetUpdateDialog) {
        this.sheetUpdateDialog.messageChild(JSON.stringify({
          message: this.contentName,
          statusOnly: true,
          note: 'Please do not close this dialog box until the operation is completed and do not switch workbooks.'
        }));
      }
      this.cd.detectChanges();
      this.tableName = `Entity_${this.selectedEntity?.id}`;
      table.name = this.tableName;
      console.info(`[Excel load ${loadDiagnosticId}] Table creation queued`, {
        tableName: this.tableName,
        rowCount,
        columnCount: columnCounts
      });
      // Commit the replacement table before resolving it by name for validation
      // and event registration. This is required when a reload reuses the table name.
      await context.sync();
      const settings = context.workbook.settings;
      this.queueValidationErrorSettings(settings, this.tableName, []);
      this.addPostDataValidation(sheet, this.headers, context, data);
      this.sheetFormating(sheet);
      currentSheetData = currentSheetData.map((el: any) => { return el.permission });
      this.addEntityMetaData(this.filter, this.selectedEntity, currentSheetData);
      this.getAllTableBySheet()
      this.onChangedEventHandler = table.onChanged.add(this.excelChangeEvent.bind(this));
      await this.readOnlyColumns(sheet, this.headers, currentSheetData);
      context.runtime.enableEvents = true;
      await context.sync();
      changeDetectionEventInProgress = false;
      if (!this.sheetUpdateDialog) {
        throw new Error(`The worksheet progress dialog closed before the operation completed. Office event: ${this.progressDialogCloseError ?? 'unknown'}.`);
      }
      this.overLay = false;
      if (!!this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.entityId = this.selectedEntity?.id;
      this.loading = false;
      this.overLay = false
      this.sheetLoaded[this.entity?.displayName.trim().replace(/\s+/g, "")] = true;
      const completionMessage = `Loading completed: ${writtenRows.toLocaleString()} rows updated`;
      this.message = {
        message: completionMessage,
        type: 'success'
      };
      this.unsubscribeNetwork();
      this.reloadRequired = false;
      this.contentName = completionMessage;
      this.indexeddbService.closeDb();
      this.cd.detectChanges();
      this.clearMessage();
      excelLoadSucceeded = true;
    })
      .catch((error: any) => {
        changeDetectionEventInProgress = false;
        this.safeExcelRun(async (context: any) => {
          context.runtime.enableEvents = true;
          await context.sync();
        });
        console.error("Error adding data to rows:", error);
        console.error(`[Excel load ${loadDiagnosticId}] Failed`, {
          elapsedMs: Date.now() - loadStartedAt,
          entityId: this.selectedEntity?.id,
          headerCount: this.headers?.length,
          name: error?.name,
          code: error?.code,
          message: error?.message,
          traceMessages: error?.traceMessages,
          debugInfo: error?.debugInfo
        });
        this.loading = false;
        this.overLay = false;
        if (error?.code === 'ItemNotFound' || error?.message?.includes("doesn't exist")) {
          this.message = {
            message: 'The sheet or resource was removed. Please reload the data.',
            type: 'error'
          };
        } else if (error?.message?.includes('lost focus') || error?.message?.includes('multiple workbooks')) {
          this.message = {
            message: 'Please switch back to this workbook and try again.',
            type: 'error'
          };
        } else if (error?.message?.includes('progress dialog closed')) {
          this.message = {
            message: 'Loading stopped because the progress dialog was closed before the worksheet update completed.',
            type: 'error'
          };
        } else {
          this.message = {
            message: 'An error occurred while loading data. Please try again.',
            type: 'error'
          };
        }
        if (this.sheetUpdateDialog) {
          const failedDialog = this.sheetUpdateDialog;
          failedDialog.messageChild(JSON.stringify({
            message: this.message.message,
            statusOnly: true,
            completed: true
          }));
          setTimeout(() => {
            try { failedDialog.close(); } catch { }
            if (this.sheetUpdateDialog === failedDialog) {
              this.sheetUpdateDialog = null;
            }
          }, 2000);
        }
        this.cd.detectChanges();
        this.clearMessage();
      });
    if (excelLoadSucceeded && this.sheetUpdateDialog) {
      const completedDialog = this.sheetUpdateDialog;
      completedDialog.messageChild(JSON.stringify({
        message: `Loading completed: ${writtenRows.toLocaleString()} rows updated`,
        statusOnly: true,
        completed: true
      }));
      setTimeout(() => {
        completedDialog.close();
        if (this.sheetUpdateDialog === completedDialog) {
          this.sheetUpdateDialog = null;
        }
      }, 1200);
    }
    console.info(`[Excel load ${loadDiagnosticId}] Finished`, {
      elapsedMs: Date.now() - loadStartedAt
    });
    this.apiResponse[this.selectedEntity.id] = [];
    this.deletedResponse[this.selectedEntity.id] = [];
    this.erroBatch[this.selectedEntity.id] = [];
    this.apiErrorResponse[this.selectedEntity.id] = [];
  }

  close() {
    this.message = '';
    this.cd.detectChanges();
  }

  public sheetFormating(sheet: any) {
    const range = sheet.getUsedRange();
    range.format.autofitColumns();
    range.format.autofitRows();
    range.format.horizontalAlignment = "Left";
    range.format.protection.locked = false;
    this.headers.forEach((item: any, index: any) => {
      const columnLetter = ExcelHelper.getColumnLetter(index);
      const headerName = String(item?.name || '').toLowerCase();
      const headerKey = String(item?.selectColumn || item?.column || item?.name || '').toLowerCase();
      const normalizedHeaderName = headerName.replace(/[^a-z0-9]/g, '');
      const normalizedHeaderKey = headerKey.replace(/[^a-z0-9]/g, '');
      const alwaysVisibleAuditHeaders = ['createdon', 'updatedon', 'lastupdatedon'];
      const isAlwaysVisibleAuditHeader = alwaysVisibleAuditHeaders.includes(normalizedHeaderName)
        || alwaysVisibleAuditHeaders.includes(normalizedHeaderKey);
      const alwaysHidden = ['id', '__row_identifier', 'changedindices'].includes(headerKey);
      const hiddenSystemHeader = [
        'id',
        'validation status',
        '__row_identifier',
        'input status',
        'validation message',
        'input message',
        'changed indices'
      ].includes(headerName);
      if (columnLetter && (
        alwaysHidden ||
        hiddenSystemHeader ||
        headerName.endsWith('_id') ||
        (item.systemAttribute && !this.showSytsemAttribute && !isAlwaysVisibleAuditHeader)
      )) {
        sheet.getRange(`${columnLetter}:${columnLetter}`).columnHidden = true;
      }
      return
    });
  }

  public async readOnlyColumns(sheet: any, header: any, _record: any) {
    await header.forEach((item: any, index: number) => {
      const columnLetter = ExcelHelper.getColumnLetter(index);
      let lockColumn = sheet.getRange(`${columnLetter}:${columnLetter}`);
      if (['READ', 'DENY'].includes(item.permission)) {
        this.readColumns.push(`${columnLetter}:${columnLetter}`);
        if (lockColumn) {
          lockColumn.format.protection.locked = true;
          lockColumn.format.fill.color = "#c5c5c5";
        }
      }
    })
  }

  public async updateCellWithStatus(sheet: any, record: any, context: any, type?: any) {
    let messages: any = [];
    if (![null, undefined].includes(record.ruleValidations))
    // if record.rulevalidation are not empty
    {
      for (let i = 0; i < record.ruleValidations.length; i++) {
        let ruleVal = record.ruleValidations[i];
        const rowNumber = ruleVal?.output.__ROW_IDENTIFIER;
        let inputValue = sheet.getRange(`D${rowNumber}`);
        let validationInput = sheet.getRange(`B${rowNumber}`);
        let validationMessageField = sheet.getRange(`C${rowNumber}`);
        for (let validationIndex = 0; validationIndex < ruleVal.ruleResults.length; validationIndex++) {
          const failedRule = ruleVal.ruleResults[validationIndex];
          messages.push(failedRule.message);
          if (!failedRule.success) {
            this.validation = true;
            validationInput.values = [['Validation Failed']];
            inputValue.values = [['Error']];
            const range = sheet.getRange(`B${rowNumber}`);
            range.getUsedRange().format.font.color = "#c5261f";
            this.validation = false;
          }
          const inputStatus = this.readColumns.length > 0 ? 'Read Only' : 'Unchanged';
          if (type === 'changed') {
            inputValue.values = [[inputStatus]];
          }
        }
        const concatenatedString = messages.join('\n');
        // find the particular row and then adding the message
        validationMessageField.values = [[concatenatedString]];
        messages = [];
        if (ruleVal.succes) {
          validationInput.values = [["Validation Succeeded"]];
        }
      }
    }
    else {
      // if record.rulevalidation are empty
      if (record?.result?.length > 0) {
        for (let i = 0; i < record.result.length; i++) {
          let ruleVal = record.result[i];
          const rowNumber = ruleVal?.__ROW_IDENTIFIER;
          let inputValue = sheet.getRange(`D${rowNumber}`);
          let validationInput = sheet.getRange(`B${rowNumber}`);
          const inputValues = this.readColumns.length > 0 ? ['Read Only'] : ['Unchanged'];
          const validationValues = ['Validation Succeeded'];
          if (type === 'changed') {
            inputValue.values = [inputValues];
          }
          validationInput.values = [validationValues];
        }
      }
    }
    await context.sync();
  }

  public removeFilters() {
    if (this.filter.length > 0) {
      this.excelRun();
    }
  }

  // Handle this function to add the validation in columns
  private addPostDataValidation(sheet: any, headers: any, _context: any, _record: any) {
    headers.forEach(async (el: any, index: number) => {
      const columnLetter = ExcelHelper.getColumnLetter(index);

      if (el.name === "Code" && el.isAuto == false && !!sheet.tables) {
        let range = sheet.tables.getItem(this.tableName).columns.getItem(el.name).getDataBodyRange()
        range.dataValidation.ignoreBlanks = false
        range.dataValidation.rule = {
          custom: {
            formula: `=AND(COUNTIF(${columnLetter}:${columnLetter}, ${columnLetter}2)=1, OR(LEN(${columnLetter}2)>0,NOT(ISBLANK(${columnLetter}2))))`
          }
        };
        range.dataValidation.errorAlert = {
          message: "No duplicates or null allowed for code",
          showAlert: true, // The default is 'true'.
          style: Excel.DataValidationAlertStyle.stop,
          title: "Duplicate value entered"
        };
      }
      if (el.formType === "FREE_FORM") {
        switch (el.dataType) {
          // case 'date':
          //   if (!!sheet.tables) {
          //     let range = sheet.tables.getItem(this.tableName).columns.getItem(el.name).getDataBodyRange()
          //     range.format.numberFormat = el.dateFormat;
          //     range.dataValidation.rule = {
          //       date: {
          //         formula1: "01/01/1900",
          //         formula2: "12/31/9999",
          //         operator: Excel.DataValidationOperator.between
          //       }
          //     };
          //     range.dataValidation.errorAlert = {
          //       message: `Sorry, enter a correct date format. e.g ${el.dateFormat}`,
          //       showAlert: true,
          //       style: Excel.DataValidationAlertStyle.stop,
          //       title: "Data Type Mismatch"
          //     };
          //   }
          //   break;
          // case 'number':
          //   if (!!sheet.tables) {
          //     let range = sheet.tables.getItem(this.tableName).columns.getItem(el.name).getDataBodyRange()
          //     // range.numberFormat = [['0.########']];
          //     range.dataValidation.rule = {
          //       custom: {
          //         formula: `=AND(ISNUMBER(${columnLetter}2), OR(${columnLetter}2 >= 0, ${columnLetter}2 < 0))`
          //       }
          //     };
          //     range.dataValidation.errorAlert = {
          //       message: "Sorry, only numbers are allowed",
          //       showAlert: true, // The default is 'true'.
          //       style: Excel.DataValidationAlertStyle.stop,
          //       title: "Data Type Mismatch"
          //     };
          //   }
          //   break;
          default:
            break;
        }
      }
    })
  }

  async addPreHeaderDataValidation(sheet: any, headers: any, context: any) {
    const worksheets = context.workbook.worksheets;
    worksheets.load('items/name');
    await context.sync();
    const worksheetNames = new Set(
      worksheets.items.map((worksheet: any) => String(worksheet.name).toLowerCase())
    );

    headers.forEach((el: any, index: number) => {
      const columnLetter = ExcelHelper.getColumnLetter(index);
      let columnRange = sheet.getRange(`${columnLetter}:${columnLetter}`);
      // const domainElementscount = this.headers.find((domAtt: any) => domAtt.name === el.selectColumn)?.elements;
      if (el.formType === "LOOKUP" && el.totalElements < this.totalElementLimit) {
        const lookupSheetName = 'Lookup_' + el.referencedTableId;
        if (!worksheetNames.has(lookupSheetName.toLowerCase())) {
          console.warn(`Skipping data validation because ${lookupSheetName} does not exist.`);
          return;
        }
        const showDropdown: boolean = el?.permission !== 'READ';
        let sourceRange = worksheets.getItem(lookupSheetName).getRange('A:A');

        columnRange.dataValidation.rule = {
          list: {
            source: sourceRange,
            formulaHidden: false,
            inCellDropDown: showDropdown,
          }
        };
        columnRange.dataValidation.errorAlert = { showAlert: false, };
      }

      if (el.formType === "LOOKUP" && el.totalElements > this.totalElementLimit) {
        columnRange.numberFormat = [['@']];
      }
      if (el.systemAttribute || el.autoColumn || el.autoGenerated) {
        this.autoColumns.push(`${columnLetter}:${columnLetter}`)
        columnRange.format.fill.color = "#c5c5c5";
      }
      else if (el.formType === "FREE_FORM") {
        switch (el.dataType) {
          case 'string':
            columnRange.numberFormat = [['@']];
            break;
          // case 'number':
          //   // columnRange.numberFormat = [['0.########']];
          //   columnRange.dataValidation.rule = {
          //     custom: {
          //       formula: `=AND(ISNUMBER(${columnLetter}2), OR(${columnLetter}2 >= 0, ${columnLetter}2 < 0))`
          //     }
          //   };
          //   columnRange.dataValidation.errorAlert = {
          //     message: "Sorry, only numbers are allowed",
          //     showAlert: true, // The default is 'true'.
          //     style: Excel.DataValidationAlertStyle.stop,
          //     title: "Data Type Mismatch"
          //   };
          //   break;

          default:
            break;
        }
      }
    })
  }

  public async showHideStatus(title: any) {
    const status = title === 'Hide Status';
    [this.btnTitle, this.icon_name] = status ? ['Show Status', 'grid_on'] : ['Hide Status', 'grid_off'];
    this.cd.detectChanges();
    await this.safeExcelRun(async (context: any) => {
      //   // Get the active worksheet
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      sheet.getRange('B:E').columnHidden = status;
      await context.sync();

    });
  }


  public async setAllColors(sheet: any, context: any) {
    // Iterate through each item in readColumns and apply a grey color for readonly
    this.readColumns.forEach((item: string | number) => {
      if (typeof item === 'string') {
        // Handle the case where item is a range string
        const range = sheet.getRange(item);
        range.format.fill.color = "#c5c5c5";
      } else if (typeof item === 'number') {
        // Handle the case where item is a row index
        const fullRow = sheet.getRangeByIndexes(item, 0, 1, this?.headers?.length - 1);
        fullRow.format.fill.color = "#c5c5c5";
      }
    });
    this.autoColumns.forEach((columnRange: any) => {
      const lockColumn = sheet.getRange(columnRange);
      lockColumn.format.fill.color = "#c5c5c5";
    })
    await context.sync();
  }

  public async updateDomainAttributeFields(records: any) {
    const array = await Promise.all(records.map(async (item: any) => {
      const publishItem: any = {};

      // Iterate over the keys of the object
      for (const headerItem of this.visibleHeaders) {
        const key = headerItem.selectColumn;
        const value = item[headerItem.selectColumn];

        if (!!value && headerItem.dataType === 'date') {
          const milliseconds = (value - 25569) * 86400 * 1000;
          var m = moment(milliseconds).utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format()
          publishItem[key] = m;
        }
        else if (headerItem && headerItem.formType === 'LOOKUP') {
          let attribute: any = null;
          if (!!value && value !== '#N/A' && headerItem.totalElements < this.totalElementLimit) {
            attribute = await this.getDomainId(value, headerItem.referencedTableId);
          }
          publishItem[key] = headerItem.totalElements > this.totalElementLimit ? value : !!attribute ? attribute.id : "";
          publishItem[`${key}_code`] = !!attribute ? attribute.code : null;
          publishItem[`${key}_name`] = !!attribute ? attribute.name : null;
        }
        else if (value === '#N/A') {
          publishItem[key] = null;
        }
        else {
          publishItem[key] = value;
        }
      }
      delete publishItem['validationstatus'];
      delete publishItem['inputstatus'];
      delete publishItem['validationmessage'];
      delete publishItem['inputmessage'];
      return publishItem;
    }));
    return array;
  }


  private async getDomainId(value: string, referencedTableId: string) {
    let code = value;
    if (value.toString().includes('{') && value.toString().includes('}')) {
      code = value.split('{')[0];
    }
    const record = await this.indexeddbService.getDataByKey('Lookup_' + referencedTableId, code.toString());
    return record;
  }

  public clearMessage() {
    const messageToClear = this.message;
    setTimeout(() => {
      if (this.message === messageToClear) {
        this.message = '';
        this.cd.detectChanges();
      }
    }, 4000);
  }

  public combineHeaderAndData(header: any[], data: any[]): any[] {
    const combinedData: any[] = [];

    // Iterate through the data array
    for (const row of data) {
      const rowData: any = {};

      // Iterate through the header array and assign values from the corresponding row
      for (let i = 0; i < header[0].length; i++) {
        rowData[header[0][i]] = row[i];
      }

      // Push the row data object to the combinedData array
      combinedData.push(rowData);
    }

    return combinedData;
  }

  public async getAllDomainApi() {
    await this.indexeddbService.ensureDbOpen();
    this.checkNetwork();
    this.entityId = this.selectedEntity.id;
    await this.safeExcelRun(async (context: any) => {
      const worksheets = context.workbook.worksheets;
      worksheets.load("items/name");
      await context.sync();
      const duplicateLookupRemovedHeaders: any = this.appUtilityService.removeDuplicatesBasedOnKey(this.headers, 'referencedTableId')
      for (const item of duplicateLookupRemovedHeaders) {
        if (this.reloadRequired) {
          break;
        }
        if (item.formType === 'LOOKUP') {
          // const existingSheet = worksheets.items.find((sheet: any) => sheet.name === item.selectColumn);
          // if (!existingSheet) {
          this.currentPage = 0;
          if (item?.totalElements < this.totalElementLimit && !this.reloadRequired) {
            await this.createSheetAndAddData(item, worksheets, context);
          }
          // }
        }
      }
      await context.sync();
    });
  }

  public addDisplayNameInFilter(query?: any) {
    const updatedHeaders = this.headers.map((item: any) => {
      const res = item.column.split(",");
      if (res.length > 1) {
        const col = res.find((el: any) => el.endsWith("_code"));
        if (!!col) {
          return { ...item, column: col };
        }
      }
      return { ...item };
    });

    const validationStatus: any = [{
      dataType: "boolean",
      name: "Validation Status",
      formType: "FREE_FORM",
      column: "is_valid",
      options: undefined,
      isFilterable: true,
      referencedTableId: null,
      selectColumn: 'validationstatus',
      systemAttribute: false,
      width: 100,
      autoColumn: true
    }];
    updatedHeaders.push(validationStatus);

    if (!!query && query.rules) {
      query.rules.forEach((el: any) => {
        const item: any = updatedHeaders.find(
          (elm: any) => elm.column === el.field
        );
        if (el?.rules && el?.rules.length > 0) {
          this.addDisplayNameInFilter(el); // Recursively process sub-rules
        }
        if (!!item) {
          el.displayName = item.name;
        }
        if (el.field === "is_valid") {
          el.displayName = "Validation Status";
        }
        return;
      });
    }
    return updatedHeaders;
  }

  public async getLookupData(item: any): Promise<any> {
    let lookupdata: any = [];
    if (item?.referencedTableId) {
      let currentPage = 0;
      let totalPages = 1; // Initialize to 1 to enter the loop

      while (currentPage < totalPages) {
        const pageSize = item.totalElements >= environment.TOTALELEMENTS ? 1 : environment.PAGESIZE;
        const { entityData } = await this.loadLookupData(item?.referencedTableId, currentPage, pageSize);
        lookupdata.push(...entityData.content);
        // if (currentPage === 0 && entityData.totalElements >= this.totalElementLimit) {
        //   this.domainAttributesArray.push({ name: item.selectColumn, elements: entityData.totalElements });
        // }
        currentPage++;
        totalPages = entityData.totalPages;
        // item.totalElements = entityData.totalElements;
        // Check if totalPages exceeds 15,000
        if (entityData.totalElements >= this.totalElementLimit) {
          break;
        }
      }
    }
    return lookupdata;
  }

  public async createSheetAndAddData(item: any, worksheets: any, context: any) {
    await this.tryCatchWrapper(async () => {
      let lookupdata: any = [];
      let dbData: any = [];
      let sheets = worksheets;

      const data = await this.getLookupData(item);
      const totalElements = this.domainAttributesArray.find((el: any) => el.name === item.selectColumn);
      if (!totalElements) {
        if (!!data?.length) {
          lookupdata = data;
          dbData = data;
          dbData = dbData.map((el: any) => ({
            ...el,
            key: el?.code?.toString()
          }));
        }
        let newSheet: any;
        const existingSheet = sheets.items.find((sheet: any) => sheet.name === 'Lookup_' + item?.referencedTableId);
        if (!existingSheet) {
          newSheet = context.workbook.worksheets.add('Lookup_' + item?.referencedTableId);
          newSheet.visibility = 'hidden';
        }
        else {
          newSheet = context.workbook.worksheets.getItem('Lookup_' + item?.referencedTableId);
          let range = newSheet.getUsedRangeOrNullObject();
          await context.sync();
          if (!range.isNullObject) {
            range.clear();
          }
        }

        await this.tryCatchWrapper(async () => {
          await this.indexeddbService.addStore('Lookup_' + item?.referencedTableId, 'key');
          await this.indexeddbService.addBulkData('Lookup_' + item?.referencedTableId, dbData);
        }, `Error adding bulk data to:', 'Lookup_' + ${item?.referencedTableId}`);

        // Extract the "code" property from each object in the dataArray
        let values = lookupdata?.map((item: any) => {
          const name = !item.name ? '' : item.name;
          const code = !item.code ? '' : item.code;
          const value = !!name && !!code ? `${code}{${name}}` : !name && code ? `${code}` : name;
          return [value, item.id]
        });
        const lookupRange = newSheet.getRange(`A1:B${values.length}`);
        lookupRange.values = values;

      }
    }, 'createDataSheet');
  }

  public loadLookupData(id: number, pageNumber: any, pageSize: number): Promise<any> {
    return new Promise((resolve, rejects) => {
      this.entityService.loadLookupData(id, pageNumber, pageSize, [], [{ direction: "ASC", property: "code" }]).pipe(
        takeUntil(this.subscription$)
      ).subscribe(
        (entityData: any) => {
          resolve({
            entityData,
          });
        },
        (err: any) => {
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          this.loading = false;
          this.overLay = false
          rejects({
            entityData: [],
          });
        }
      );
    });
  }
  public async getAllTableBySheet() {
    await this.safeExcelRun(async (context: any) => {
      const tables = context.workbook.tables;
      tables.load('items/name');
      await context.sync();
      if (tables.items.length > 0) {
        this.addedSheetsNames = tables.items.map((elm: any) => elm.name);
      }
    });
  }


  // Handle this function for clear the cells
  public async clearExcelCells(removeSheet: boolean, removeData: boolean, entity: any) {
    this.readColumns = [];
    this.autoColumns = [];
    if (this.onChangedEventHandler) {
      await this.removeEventHandler();
    }
    try {
      await Excel.run({ delayForCellEdit: true }, async (context: any) => {
        // let sheet = context.workbook.worksheets.getActiveWorksheet();
        let sheets = context.workbook.worksheets;
        sheets.load("items/name");
        // sheet.protection.unprotect("SIM8Eight#");
        await context.sync();
        const sheetName = this.handleSheetName(entity?.displayName);

        // Handle sheet removal and data removal
        if (removeSheet || removeData) {
          const existingSheetIndex = sheets.items.findIndex((sheet: any) => sheet.name === sheetName);
          let newSheet;

          if (existingSheetIndex !== -1) {
            const existingSheet = sheets.items[existingSheetIndex];
            await this.renameSheet(existingSheet, "Deleted");

            newSheet = sheets.add(sheetName);
            newSheet.activate();

            await context.sync();
            existingSheet.delete();
          } else {
            newSheet = sheets.add(sheetName);
            newSheet.activate();
          }

          newSheet.name = sheetName;
          if (removeSheet) {
            await this.deleteOtherSheets(sheets, sheetName, context);
          }
        }
        await context.sync();
      });
    } catch (error: any) {
      console.error("Error:", error.message);
      if ((window as any).OfficeExtension && error instanceof (window as any).OfficeExtension.Error) {
        console.error("Debug info:", JSON.stringify(error.debugInfo));
      }
    }
  }

  public async renameSheet(sheet: any, newName: string) {
    sheet.name = newName;
    await sheet.context.sync();
  }

  public async deleteOtherSheets(sheets: any, _excludeSheetName: string, _context: any) {
    for (const item of sheets.items) {
      if (['Sheet1'].includes(item.name)) {
        item.delete();
      }
      // if (item.name !== excludeSheetName) {
      //   item.delete();
      // }
    }
    // await context.sync();
  }

  public handleSheetName(name: string) {
    let sheetName: any = name.trim();
    if (sheetName.length > 31) {
      sheetName = sheetName.substring(0, 31);
    }
    return sheetName;
  }

  public async convertSheetToTable(sheet: any, context: any, usedRange: any) {
    this.contentName = 'Updating Sheet...'
    const startRow = 0;
    const startColumn = 0;
    const rowCount = usedRange.rowCount;
    const columnCounts = usedRange.columnCount;

    // Get the range of the data to be converted to a table
    const dataRange = sheet.getRangeByIndexes(startRow, startColumn, rowCount, columnCounts);

    // Convert the range to a table
    const table = sheet.tables.add(dataRange, true /* hasHeaders */);
    this.tableName = `Entity_${this.selectedEntity?.id}`;
    table.name = this.tableName;
    this.onChangedEventHandler = table.onChanged.add(this.excelChangeEvent.bind(this));
    const columnCRange = sheet.getRange('C:C').getUsedRange();
    columnCRange.format.load("wrapText");
    // Enable text wrapping for column C
    columnCRange.format.wrapText = false;
    await context.sync();
    // if all the record are got delete
    if (this.previousTableDatas?.length === 1 &&
      Object.values(this.previousTableDatas[0]).every(value => value?.toString()?.trim() === "")) {
      await this.manageRowIdentifierRow(sheet);
      await context.sync();
    }
    this.contentName = 'Updating Sheet Completed...'
    if (!this.isCodeNull) {
      this.message = {
        message: 'Rules Validated Successfully.',
        type: 'success'

      }
    }
    this.unsubscribeNetwork();
    this.reloadRequired = false;
    if (!!this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.loading = false;
    this.disablePublishButton = false;
    this.overLay = false
    this.indexeddbService.closeDb();
    if (!!this.currentDialog) {
      this.currentDialog.close()
    }
    if (!!this.intervalId) {
      clearInterval(this.intervalId);
    }
    // sheet.getUsedRange().format.autofitColumns();
    // sheet.getUsedRange().format.autofitRows();
    // clearInterval(this.intervalId);
    this.cd.detectChanges();
    // this.clearMessage();
  }
  checkSheetPermission() {
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/missing/load`, { height: 30, width: 30 },
      (asyncResult: any) => {
        const dialog = asyncResult.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, () => {
          dialog.close();
          setTimeout(() => {
            this.openDialogBox(this.entity);
          }, 100);
          // this.reloadData();
        })
      }
    );
  }

  public handleMismatchVersionDialog(message: any) {
    this.loading = false;
    this.cd.detectChanges();
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/confirm`,
      { height: 30, width: 30 },
      (item) => {
        const dialog = item.value;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            if (arg?.message === 'send') {
              setTimeout(() => {
                const data = { message: message, ok: 'Ok' }
                dialog.messageChild(JSON.stringify(data));
              }, 800);
            }
            if (arg?.message == 'continue') {
              dialog.close();
            }
          });
      });
  }

  public async publishRecords() {
    const isOnlineBeforePublish = await this.checkPublishConnectivity();
    if (!isOnlineBeforePublish) {
      this.stopPublishNetworkMonitor();
      if (!!this.currentDialog) {
        this.currentDialog.close();
      }
      this.message = {
        message: 'Publish could not be started due to network error. Please check your connection and try again.',
        type: 'warning'
      }
      this.publishStatusLines = ['Status: Offline', 'No batch was sent to server.'];
      this.cd.detectChanges();
      this.handleOfflineDialog();
      return;
    }

    this.publishStatusLines = [
      'Phase: Preparing data for publish',
      'Step: Validating network and collecting worksheet rows'
    ];
    this.contentName = 'Loading Batches...'
    this.apiResponse[this.selectedEntity.id] = [];
    this.deletedResponse[this.selectedEntity.id] = [];
    this.erroBatch[this.selectedEntity.id] = [];
    this.apiErrorResponse[this.selectedEntity.id] = [];
    let publishDataValues: any[] = [];
    await this.safeExcelRun(async (context: any) => {
      const sheet = context.workbook.worksheets.getItem(this.selectedEntity?.displayName);
      const range = sheet.getUsedRange();
      range.load(["rowCount", "columnCount"]);
      await context.sync();
      this.rowCount = range.rowCount;
      this.columnCount = range.columnCount;
      this.publishStatusLines = [
        `Phase: Building batches from worksheet data`,
        `Rows identified: ${this.rowCount}`,
        `Batch size: ${environment.PUBLISHRECORD}`
      ];
      publishDataValues = await this.loadBatch(sheet, context);
    });

    if (publishDataValues.length === 0) {
      return;
    }

    // Keep network operations outside Excel.run so the workbook context is not
    // held open while connectivity is being checked.
    const isOnlineBeforeBatchPublish = await this.checkPublishConnectivity();
    if (!isOnlineBeforeBatchPublish) {
      this.stopPublishNetworkMonitor();
      if (!!this.currentDialog) {
        this.currentDialog.close();
      }
      this.message = {
        message: 'Publish information could not be sent due to network error. Please check your connection and Republish.',
        type: 'warning'
      };
      this.publishStatusLines = ['Status: Offline before send', 'No batch was sent to server.'];
      this.cd.detectChanges();
      this.handleOfflineDialog();
      return;
    }

    this.publishHasApiErrors = false;
    this.publishFailedBatchCount = 0;
    this.publishRetriedBatchCount = 0;
    this.publishRetryAttemptTotal = 0;
    this.publishApiWarningRecordCount = 0;
    this.publishFailedRecordCount = 0;
    this.publishHasNetworkError = false;
    this.publishCurrentBatch = 0;
    this.publishTotalBatches = 0;
    this.publishNetworkStatus = 'Online';
    this.publishFailedBatchRecordMap = {};
    this.publishUnconfirmedBatchRecordMap = {};
    this.publishRetriedBatchMap = {};
    this.publishAwaitingAcknowledgement = false;
    this.publishProgress = { totalRecords: 0, processedRecords: 0, batchStatus: 'success', retryCount: 0 };
    this.publishStatusLines = [
      'Phase: Sending batches to publish worker',
      `Total worksheet rows queued: ${publishDataValues.length}`,
      `Batch size: ${environment.PUBLISHRECORD}`
    ];
    this.overLay = true;
    this.loading = true;
    this.startPublishNetworkMonitor();
    this.publishWorker.postMessage(
      {
        rows: publishDataValues,
        batchSize: environment.PUBLISHRECORD,
        version: environment.VERSION,
        headers: this.headers,
        totalElementLimit: this.totalElementLimit,
        api_url: environment.API_DATA_URL,
        token: localStorage.getItem('token'),
        entityId: this.entityId,
        entityName: this.selectedEntity?.name,
        readColumns: this.readColumns.length === this.currentSheetHeaders.length,
      }
    );
  }

  private async loadBatch(sheet: any, context: any) {
    let batchData = [];
    const batchSize = environment.PUBLISHRECORD;
    const totalBatch = Math.ceil(this.rowCount / environment.PUBLISHRECORD);
    const totalRows = this.rowCount;
    for (let i = 0; i < totalBatch; i++) {
      const startIndex = i * batchSize;
      const endIndex = Math.min(startIndex + batchSize, totalRows);
      const batch = sheet.getRangeByIndexes(startIndex, 0, endIndex - startIndex, this.columnCount);
      batch.load("values");
      await context.sync();
      batchData.push(...batch.values);
    }
    return batchData;
  }

  private resolveFailedRecordCount(result: any): number {
    if (!result?.failedAfterRetry) {
      return 0;
    }

    if (Array.isArray(result?.data) && result.data.length > 0) {
      return result.data.length;
    }

    return Number(result?.failedRecordCount || 0);
  }

  private getPublishRunLevelStatus(): 'success' | 'failed' {
    const unresolvedFailedRecords = Object.values(this.publishFailedBatchRecordMap)
      .reduce((sum: number, val: any) => sum + Number(val || 0), 0);
    const unresolvedUnconfirmedRecords = Object.values(this.publishUnconfirmedBatchRecordMap)
      .reduce((sum: number, val: any) => sum + Number(val || 0), 0);

    return (unresolvedFailedRecords > 0 || unresolvedUnconfirmedRecords > 0 || this.publishApiWarningRecordCount > 0)
      ? 'failed'
      : 'success';
  }

  private getEstimatedServerProcessingMinutes(totalRecords: number): number {
    const records = Math.max(0, Number(totalRecords) || 0);
    return Math.max(1, Math.ceil(records / environment.SERVER_PROCESSING_RECORDS_PER_MINUTE));
  }

  private async publishWorkerMessage(event: MessageEvent) {
    const result = event.data
    this.publishCurrentBatch = result.count || this.publishCurrentBatch;
    this.publishTotalBatches = result.totalBatchPublish || this.publishTotalBatches;
    if (result?.progress) {
      this.publishProgress = {
        totalRecords: result.progress.totalRecords || this.publishProgress?.totalRecords || 0,
        processedRecords: result.progress.processedRecords || 0,
        batchStatus: this.publishProgress?.batchStatus || 'success',
        retryCount: this.publishRetryAttemptTotal || 0
      };
    }
    const completedBatchCount = Number(result.count) || 0;
    const totalBatchCount = Number(result.totalBatchPublish) || 0;
    const displayedBatchNumber = totalBatchCount > 0
      ? Math.min(completedBatchCount + 1, totalBatchCount)
      : 0;
    this.contentName = `Publishing changes batch ${displayedBatchNumber} of ${totalBatchCount}`;

    const batchNumber = result.count || 0;
    const retryCount = result.retryCount || 0;
    if (retryCount > 0) {
      if (batchNumber > 0) {
        this.publishRetriedBatchMap[batchNumber] = true;
      }
      this.publishRetryAttemptTotal = this.publishRetryAttemptTotal + retryCount;
    }

    if (result.action == "ApiError" || result.failedAfterRetry) {
      this.publishHasApiErrors = true;
    }

    if (result.action === "ApiError" && !result.failedAfterRetry) {
      const warningRecords = Array.isArray(result.data) ? result.data.length : 0;
      this.publishApiWarningRecordCount = this.publishApiWarningRecordCount + warningRecords;
    }

    if (result.networkError) {
      this.publishHasNetworkError = true;
    }

    if (result.failedAfterRetry && batchNumber > 0) {
      const unresolvedRecordCount = this.resolveFailedRecordCount(result);
      if (unresolvedRecordCount > 0) {
        if (result.networkError) {
          this.publishUnconfirmedBatchRecordMap[batchNumber] = unresolvedRecordCount;
          delete this.publishFailedBatchRecordMap[batchNumber];
        } else {
          this.publishFailedBatchRecordMap[batchNumber] = unresolvedRecordCount;
          delete this.publishUnconfirmedBatchRecordMap[batchNumber];
        }
      } else {
        delete this.publishFailedBatchRecordMap[batchNumber];
        delete this.publishUnconfirmedBatchRecordMap[batchNumber];
      }
    } else if (batchNumber > 0) {
      if (this.publishFailedBatchRecordMap[batchNumber] !== undefined) {
        delete this.publishFailedBatchRecordMap[batchNumber];
      }
      if (this.publishUnconfirmedBatchRecordMap[batchNumber] !== undefined) {
        delete this.publishUnconfirmedBatchRecordMap[batchNumber];
      }
    }

    const processedRecordsSoFar = this.publishProgress?.processedRecords || 0;
    this.publishProgress = {
      totalRecords: this.publishProgress?.totalRecords || 0,
      processedRecords: processedRecordsSoFar,
      batchStatus: processedRecordsSoFar === 0 ? 'success' : this.getPublishRunLevelStatus(),
      retryCount: this.publishRetryAttemptTotal || 0
    };

    const retriedBatchNumbers = Object.keys(this.publishRetriedBatchMap).map((key: string) => Number(key));
    const retriedBatchCount = retriedBatchNumbers.length;
    const retriedFailedBatchCount = retriedBatchNumbers.filter((num: number) => this.publishFailedBatchRecordMap[num] !== undefined || this.publishUnconfirmedBatchRecordMap[num] !== undefined).length;
    const retriedSuccessBatchCount = retriedBatchCount - retriedFailedBatchCount;
    this.publishRetriedBatchCount = retriedBatchCount;

    const unresolvedFailedBatches = Object.keys(this.publishFailedBatchRecordMap).length;
    const unresolvedFailedRecords = Object.values(this.publishFailedBatchRecordMap).reduce((sum: number, val: any) => sum + Number(val || 0), 0);
    this.publishFailedBatchCount = unresolvedFailedBatches;
    this.publishFailedRecordCount = unresolvedFailedRecords;

    if (result.action === "published") {
      this.apiResponse[this.selectedEntity.id].push(...result.data);
    }
    if (result.action === "deleted") {
      console.log('Deleted records batch result:', result);
      this.deletedResponse[this.selectedEntity.id] = result;
    }
    if (result.action == "ApiError") {
      this.apiErrorResponse[this.selectedEntity.id].push(...result.data);;
    }
    if (result.action == "unauthorized") {
      this.stopPublishNetworkMonitor();
      this.currentDialog.close();
      localStorage.removeItem('token');
      this.route.navigate(['/landing']);
    }
    if (result.action === "invalid-verison") {
      this.stopPublishNetworkMonitor();
      this.currentDialog.close();
      setTimeout(() => {
        this.handleMismatchVersionDialog(result?.message)
      }, 500);
    }

    const actionLabelMap: any = {
      published: 'Published',
      deleted: 'Delete synced',
      ApiError: 'API error response',
      unauthorized: 'Unauthorized',
      'invalid-verison': 'Version mismatch'
    };
    const actionLabel = actionLabelMap[result.action] || 'Processing';
    this.publishStatusLines = [
      `Phase: Processing server responses`,
      `Batch progress: Publishing changes batch ${this.publishCurrentBatch} of ${this.publishTotalBatches}`,
      `Last action: ${actionLabel}`,
      `Retries summary: Retried batches ${retriedBatchCount} (Recovered ${retriedSuccessBatchCount}, Failed ${retriedFailedBatchCount}); Extra retry attempts ${this.publishRetryAttemptTotal}`,
      `Records published so far: ${this.publishProgress?.processedRecords || 0}`
    ];

    if (result.count == result.totalBatchPublish) {
      this.stopPublishNetworkMonitor();
      this.indexeddbService.closeDb();
      setTimeout(async () => {
        const erroBatch = Array.isArray(result.erroBatch) ? result.erroBatch : [];
        const finalFailedBatchCount = Object.keys(this.publishFailedBatchRecordMap).length;
        const finalFailedRecordCount = Object.values(this.publishFailedBatchRecordMap).reduce((sum: number, val: any) => sum + Number(val || 0), 0);
        const finalUnconfirmedBatchCount = Object.keys(this.publishUnconfirmedBatchRecordMap).length;
        const finalUnconfirmedRecordCount = Object.values(this.publishUnconfirmedBatchRecordMap).reduce((sum: number, val: any) => sum + Number(val || 0), 0);
        const reconciliationSummaryLine = `Reconciliation: Confirmed not published ${finalFailedRecordCount}, Unconfirmed due to network ${finalUnconfirmedRecordCount}`;
        const finalRetriedBatchNumbers = Object.keys(this.publishRetriedBatchMap).map((key: string) => Number(key));
        const finalRetriedBatchCount = finalRetriedBatchNumbers.length;
        const finalRetriedFailedBatchCount = finalRetriedBatchNumbers.filter((num: number) => this.publishFailedBatchRecordMap[num] !== undefined || this.publishUnconfirmedBatchRecordMap[num] !== undefined).length;
        const finalRetriedSuccessBatchCount = finalRetriedBatchCount - finalRetriedFailedBatchCount;
        const retrySummaryMessage = finalRetriedBatchCount > 0
          ? ` Retries summary: ${finalRetriedBatchCount} retried batch(es) (${finalRetriedSuccessBatchCount} recovered, ${finalRetriedFailedBatchCount} failed), with ${this.publishRetryAttemptTotal} extra retry attempt(s) in total.`
          : '';
        const retrySummaryStatusLine = finalRetriedBatchCount > 0
          ? `Retries summary: Retried batches ${finalRetriedBatchCount} (Recovered ${finalRetriedSuccessBatchCount}, Failed ${finalRetriedFailedBatchCount}); Extra retry attempts ${this.publishRetryAttemptTotal}`
          : 'Retries summary: No retries needed';
        const allBatchesFinalized = this.publishCurrentBatch >= this.publishTotalBatches
          && ((this.publishProgress?.processedRecords || 0) >= (this.publishProgress?.totalRecords || 0));
        const hasApiWarnings = this.publishApiWarningRecordCount > 0;
        const entity: any = this.entityList.find((el: any) => el.id === this.entityId);
        await this.safeExcelRun(async (context: any) => {

          if (finalFailedBatchCount === 0 && !hasApiWarnings) {
            this.addPublishStatus(context, true);
          }
          if (erroBatch.length > 0) {
            this.erroBatch[this.selectedEntity.id].push(...erroBatch);
          }
        });

        if (!allBatchesFinalized) {
          this.message = {
            message: `Publish status is still reconciling in "${entity?.displayName}". Please wait and verify before republish.${retrySummaryMessage}`,
            type: 'warning'
          }
          this.publishStatusLines = [
            'Final status: Reconciling',
            `Batches processed: ${this.publishCurrentBatch}/${this.publishTotalBatches}`,
            `Records processed: ${this.publishProgress?.processedRecords || 0}/${this.publishProgress?.totalRecords || 0}`,
            retrySummaryStatusLine
          ];
        } else if (finalFailedBatchCount > 0) {
          this.message = {
            message: `Publish incomplete in "${entity?.displayName}". ${finalFailedRecordCount} record(s) were not published. Please republish.${retrySummaryMessage}`,
            type: 'warning'
          }
          this.publishStatusLines = [
            'Final status: Incomplete',
            `Result: ${finalFailedRecordCount} record(s) not published`,
            reconciliationSummaryLine,
            'Reason: API/service errors in one or more batches',
            'Action: Review highlighted rows and Republish',
            retrySummaryStatusLine
          ];
        } else if (finalUnconfirmedBatchCount > 0) {
          this.message = {
            message: `Publish status is uncertain in "${entity?.displayName}" for ${finalUnconfirmedRecordCount} record(s) due to network interruption/timeouts. Confirmed not published: ${finalFailedRecordCount}. Some may already be published. Please refresh once and Republish only remaining changed rows.${retrySummaryMessage}`,
            type: 'warning'
          }
          this.publishStatusLines = [
            'Final status: Uncertain',
            `Result: ${finalUnconfirmedRecordCount} record(s) publish status unconfirmed`,
            reconciliationSummaryLine,
            'Reason: Network interruption/timeout after send attempt',
            'Action: Refresh once, then Republish only remaining rows',
            retrySummaryStatusLine
          ];
        } else if (hasApiWarnings) {
          this.message = {
            message: `Publish completed with some record errors in "${this.selectedEntity?.displayName}". Please review highlighted rows.${retrySummaryMessage}`,
            type: 'warning'
          }
          this.publishStatusLines = [
            'Final status: Completed with warnings',
            'Result: Some records have validation/API errors',
            'Action: Review highlighted rows',
            retrySummaryStatusLine
          ];
        } else {
          const totalPublishedRecords = this.publishProgress?.totalRecords || 0;
          const formattedRecordCount = Number(totalPublishedRecords).toLocaleString();
          const estimatedServerProcessingMinutes = this.getEstimatedServerProcessingMinutes(totalPublishedRecords);
          const minuteLabel = estimatedServerProcessingMinutes === 1 ? 'minute' : 'minutes';
          this.publishFinalRecordCount = formattedRecordCount;
          this.publishFinalProcessingTime = `${estimatedServerProcessingMinutes} ${minuteLabel}`;
          this.publishFinalRetrySummary = retrySummaryMessage.trim();
          this.publishServerProcessingReadyAt = Date.now() + (estimatedServerProcessingMinutes * 60 * 1000);
          this.message = {
            message: `The application is currently processing your ${formattedRecordCount} records. This process is expected to take approximately ${estimatedServerProcessingMinutes} ${minuteLabel} to complete. To avoid duplicate submissions, please do not resubmit the same changes until processing is complete. Thank you for your patience.${retrySummaryMessage}`,
            type: 'success'
          }
          this.publishStatusLines = [
            'Final status: Success',
            `Result: All ${result.totalBatchPublish} batches processed successfully`,
            'No pending publish errors',
            retrySummaryStatusLine
          ];
        }

        this.loading = false;
        this.overLay = false;
        hasChangedRow = false;

        this.publishAwaitingAcknowledgement = true;
        this.publishProgress = {
          totalRecords: this.publishProgress?.totalRecords || 0,
          processedRecords: this.publishProgress?.totalRecords || this.publishProgress?.processedRecords || 0,
          batchStatus: (finalFailedBatchCount > 0 || finalUnconfirmedBatchCount > 0) ? 'failed' : (this.publishRetryAttemptTotal > 0 ? 'retry' : 'success'),
          retryCount: this.publishRetryAttemptTotal || 0
        };

        if (!!this.currentDialog) {
          this.currentDialog.messageChild(JSON.stringify({
            action: 'publish',
            message: this.contentName,
            progress: this.publishProgress,
            networkOnline: this.publishNetworkStatus === 'Online',
            requireAcknowledgement: true,
            finalMessage: this.message?.message || '',
            finalRecordCount: this.publishFinalRecordCount,
            finalProcessingTime: this.publishFinalProcessingTime,
            finalRetrySummary: this.publishFinalRetrySummary
          }));
        }

        if (!!this.intervalId) {
          clearInterval(this.intervalId)
        }
        this.publishStatusLines = [];
        this.cd.detectChanges();
        if (result.lookupError) {
          setTimeout(() => {
            this.displayMessage()
          }, 600);
        }
      }, 1000);
    }
  }

  private startPublishNetworkMonitor() {
    this.stopPublishNetworkMonitor();
    this.publishNetworkCheckIntervalId = setInterval(async () => {
      const isOnline = await this.checkPublishConnectivity();
      this.publishNetworkStatus = isOnline ? 'Online' : 'Offline';
      if (!isOnline) {
        this.publishHasNetworkError = true;
      }
      if (this.publishTotalBatches > 0) {
        const retriedBatchNumbers = Object.keys(this.publishRetriedBatchMap).map((key: string) => Number(key));
        const retriedBatchCount = retriedBatchNumbers.length;
        const retriedFailedBatchCount = retriedBatchNumbers.filter((num: number) => this.publishFailedBatchRecordMap[num] !== undefined || this.publishUnconfirmedBatchRecordMap[num] !== undefined).length;
        const retriedSuccessBatchCount = retriedBatchCount - retriedFailedBatchCount;
        this.publishStatusLines = [
          `Phase: Processing server responses`,
          `Batch progress: Publishing changes batch ${this.publishCurrentBatch} of ${this.publishTotalBatches}`,
          `Last action: Waiting for server response`,
          `Retries summary: Retried batches ${retriedBatchCount} (Recovered ${retriedSuccessBatchCount}, Failed ${retriedFailedBatchCount}); Extra retry attempts ${this.publishRetryAttemptTotal}`,
          `Records published so far: ${this.publishProgress?.processedRecords || 0}`
        ];
      }
      this.cd.detectChanges();
    }, 5000);
  }

  private async checkPublishConnectivity(): Promise<boolean> {
    if (!navigator.onLine) {
      return false;
    }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const probeUrl = `${new URL(environment.API_DATA_URL).origin}/?connectivityProbe=${Date.now()}`;

    try {
      await fetch(probeUrl, {
        method: 'GET',
        mode: 'no-cors',
        cache: 'no-store',
        signal: controller.signal
      });
      return true;
    } catch {
      return false;
    } finally {
      clearTimeout(timeout);
    }
  }

  private stopPublishNetworkMonitor() {
    if (!!this.publishNetworkCheckIntervalId) {
      clearInterval(this.publishNetworkCheckIntervalId);
      this.publishNetworkCheckIntervalId = null;
    }
  }

  displayMessage() {
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/confirm`,
      { height: 25, width: 30 },
      (item) => {
        const dialog = item.value;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            if (arg?.message === 'send') {
              setTimeout(() => {
                const data = { message: "New segment has been detected. Please reload the Data", yes: 'Reload' }
                dialog.messageChild(JSON.stringify(data));
              }, 800);
            }
            if (arg?.message === 'continue') {
              dialog.close();
              setTimeout(() => {
                this.refreshEntityRecords();
              }, 800);
            }
          })
      }
    )
  }

  async refreshResult() {
    const hasDataToRefresh =
      (this.apiResponse[this.selectedEntity.id]?.length || 0) > 0 ||
      ((this.deletedResponse[this.selectedEntity.id]) &&
        (Object.keys(this.deletedResponse[this.selectedEntity.id]).length > 0)) ||
      (this.erroBatch[this.selectedEntity.id]?.length || 0) > 0 ||
      (this.apiErrorResponse[this.selectedEntity.id]?.length || 0) > 0;

    // Show dialog even when nothing needs refreshing
    if (!hasDataToRefresh) {
      Office.context.ui.displayDialogAsync(
        `${environment.URL}/#/confirm`,
        { height: 30, width: 40 },
        (item) => {
          const dialog = item.value;
          this.currentDialog = dialog;
          dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            async (arg: any) => {
              if (arg?.message === 'send') {
                setTimeout(() => {
                  const data = { message: "No changes detected. Please continue.", ok: 'Ok' }
                  dialog.messageChild(JSON.stringify(data));
                }, 800);
              }
              // dialog.close();
              if (arg?.message === 'continue') {
                dialog.close();
              }
              if (arg?.message === 'close') {
                dialog.close();
              }
            });
        }
      );
      return;
    }

    // Calculate total records to update
    const totalPublished = this.apiResponse[this.selectedEntity.id]?.length || 0;
    const totalDeleted = this.deletedResponse[this.selectedEntity.id]?.length || 0;
    const totalErrors = this.erroBatch[this.selectedEntity.id]?.length || 0;
    const totalApiErrors = this.apiErrorResponse[this.selectedEntity.id]?.length || 0;
    const totalRecords = totalPublished + totalDeleted + totalErrors + totalApiErrors;
    let updatedRecords = 0;
    changeDetectionEventInProgress = true;
    console.log(`Total records to update: ${totalRecords} (Published: ${totalPublished}, Deleted: ${totalDeleted}, Errors: ${totalErrors}, API Errors: ${totalApiErrors})`);

    // Create and display the updating dialog
    const result = await this.showUpdatingDialog(totalRecords);

    if (!result) {
      console.error('Failed to show updating dialog');
      changeDetectionEventInProgress = false;
      return;
    }

    const { dialogRef, dialogReadyPromise } = result;
    try {
      await this.safeExcelRun(async (context: any) => {
        console.log('Starting safeExcelRun');

        const publishSheet = context.workbook.worksheets.getItem(this.selectedEntity?.displayName);

        if (this.apiResponse[this.selectedEntity.id]?.length) {
          await this.updatePublishedResponseMessage(
            publishSheet,
            this.apiResponse[this.selectedEntity.id],
            context,
            dialogRef
          );
          updatedRecords += totalPublished;
        }
        if (
          this.deletedResponse[this.selectedEntity.id] &&
          Object.keys(this.deletedResponse[this.selectedEntity.id]).length > 0
        ) {
          console.log('Updating deleted responses');
          await this.updateDeletedResponseMessage(
            publishSheet,
            this.deletedResponse[this.selectedEntity.id],
            context,
            dialogRef
          );
          updatedRecords += totalDeleted;
        }

        if (this.erroBatch[this.selectedEntity.id]?.length) {
          console.log('Updating error records');
          await this.updateErrorRecords(
            publishSheet,
            this.erroBatch[this.selectedEntity.id],
            context
          );
          updatedRecords += totalErrors;
        }

        if (this.apiErrorResponse[this.selectedEntity.id]?.length) {
          console.log('Updating API error responses');
          await this.updatePublishedApiError(
            publishSheet,
            this.apiErrorResponse[this.selectedEntity.id],
            context
          );
          updatedRecords += totalApiErrors;
        }

        console.log('Setting all colors');
        await this.setAllColors(publishSheet, context);
        await context.sync();

        this.apiResponse[this.selectedEntity.id] = [];
        this.deletedResponse[this.selectedEntity.id] = [];
        this.erroBatch[this.selectedEntity.id] = [];
        this.apiErrorResponse[this.selectedEntity.id] = [];

        // Add delay and then send completion message to dialog
        console.log('Scheduling completion message');
        setTimeout(() => {
          try {
            console.log('Sending completion message to dialog');
            const remainingProcessingMinutes = this.publishServerProcessingReadyAt === null
              ? null
              : Math.max(0, Math.ceil((this.publishServerProcessingReadyAt - Date.now()) / (60 * 1000)));
            const completionMessage = JSON.stringify({
              message: 'Refresh completed',
              isLoading: false,
              isCompleted: true,
              totalRecords: totalRecords,
              updatedRecords: updatedRecords,
              submittedRecordCount: this.publishFinalRecordCount,
              remainingProcessingMinutes,
              processingStatus: remainingProcessingMinutes === null
                ? null
                : (remainingProcessingMinutes > 0 ? 'processing' : 'ready')
            });
            console.log('Message content:', completionMessage);
            if (dialogRef && typeof dialogRef.messageChild === 'function') {
              dialogRef.messageChild(completionMessage);
              console.log('Completion message sent successfully');
            } else {
              console.error('dialogRef or messageChild is invalid');
            }
          } catch (error) {
            console.error('Error sending completion message:', error);
          }
        }, 1500);
      });

      // Wait for user to click OK
      console.log('Waiting for dialog to close');
      await dialogReadyPromise;
      console.log('Dialog closed by user');
      changeDetectionEventInProgress = false;
    } catch (error) {
      console.error('Error during refresh:', error);
      changeDetectionEventInProgress = false;
      try {
        dialogRef.close();
      } catch (e) {
        console.error('Error closing dialog:', e);
      }
    }
  }

  private showUpdatingDialog(totalRecords: number): Promise<any> {

    return new Promise((resolve) => {
      let dialogRef: any = null;
      let dialogClosed = false;

      const dialogReadyPromise = new Promise<void>((dialogResolve) => {
        Office.context.ui.displayDialogAsync(
          `${environment.URL}/#/updating-sheet`,
          { height: 40, width: 45 },
          (asyncResult: any) => {
            if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
              dialogRef = asyncResult.value;

              console.log('Dialog opened successfully');

              // User clicks OK button
              dialogRef.addEventHandler(
                Office.EventType.DialogMessageReceived,
                (arg: any) => {
                  try {
                    const message = JSON.parse(arg.message);

                    console.log('Parent received from dialog:', message);

                    if (message.action === 'close' && !dialogClosed) {
                      dialogClosed = true;

                      console.log('Closing dialog on OK button click');

                      try {
                        dialogRef.close();
                      } catch (e) {
                        console.error('Error closing dialog', e);
                      }

                      dialogResolve();
                    }
                  } catch (e) {
                    console.log('Message from dialog:', arg.message);
                  }
                }
              );

              // User clicks X button
              dialogRef.addEventHandler(
                Office.EventType.DialogEventReceived,
                (arg: any) => {
                  console.log('Dialog event received:', arg);

                  if (arg.error === 12006 && !dialogClosed) {
                    dialogClosed = true;

                    console.log('Dialog closed by user');

                    dialogResolve();
                  }
                }
              );

              // Initial loading message
              setTimeout(() => {
                try {
                  if (!dialogClosed) {
                    dialogRef.messageChild(
                      JSON.stringify({
                        message:
                          'Updating the sheet please wait. Do not switch between workbooks.',
                        isLoading: true,
                        isCompleted: false,
                        totalRecords,
                        updatedRecords: 0
                      })
                    );
                  }
                } catch (e) {
                  console.error('Failed to send initial message', e);
                }
              }, 300);

              resolve({
                dialogRef,
                dialogReadyPromise,
                isDialogClosed: () => dialogClosed
              });
            } else {
              console.error(
                'Failed to open dialog:',
                asyncResult.error?.message
              );

              resolve(null);
            }
          }
        );
      });
    });
  }

  public async updatePublishedResponseMessage(
    sheet: any,
    records: any,
    context: any,
    dialogRef: any
  ) {
    const batchSize = environment.PAGESIZE;
    const rowCount = this?.headers?.length || 0;
    let processedCount = 0;

    const recordsByRow = (records || [])
      .map((record: any) => ({
        record,
        rowNumber: Number(record?.[record.length - 1])
      }))
      .filter((item: any) => Number.isFinite(item.rowNumber))
      .sort((a: any, b: any) => a.rowNumber - b.rowNumber);

    for (const batch of this.createContiguousRowBatches(recordsByRow, batchSize)) {
      const firstRowNumber = batch[0].rowNumber;
      const range = sheet.getRangeByIndexes(
        firstRowNumber - 1,
        0,
        batch.length,
        rowCount
      );

      range.values = batch.map((item: any) => item.record);
      range.format.fill.clear();

      const successfulRows: number[] = [];
      const errorRows: number[] = [];
      const validationFailedRows: number[] = [];

      batch.forEach((item: any) => {
        const record = item.record;

        if (record[3] !== "Error" && record[1] !== "Validation Failed") {
          successfulRows.push(item.rowNumber);
        } else if (record[3] === "Error") {
          errorRows.push(item.rowNumber);
        } else {
          validationFailedRows.push(item.rowNumber);
        }
      });

      this.applyContiguousRowRanges(successfulRows, (startRow: number, count: number) => {
        sheet.getRange(`B${startRow}:E${startRow + count - 1}`).format.font.color = "#000000";
      });

      this.applyContiguousRowRanges(errorRows, (startRow: number, count: number) => {
        sheet.getRangeByIndexes(startRow - 1, 0, count, rowCount).format.fill.color = "#ffcecb";
        sheet.getRange(`D${startRow}:D${startRow + count - 1}`).format.font.color = "#c5261f";
      });

      this.applyContiguousRowRanges(validationFailedRows, (startRow: number, count: number) => {
        sheet.getRange(`B${startRow}:C${startRow + count - 1}`).format.font.color = "#c5261f";
      });

      processedCount += batch.length;
      await context.sync();

      dialogRef?.messageChild(JSON.stringify({
        publishedCount: processedCount,
        publishedTotal: records?.length || 0,
        message: `Updating published records...`
      }));
    }

  }

  private createContiguousRowBatches(recordsByRow: any[], batchSize: number): any[][] {
    const batches: any[][] = [];
    let batch: any[] = [];

    recordsByRow.forEach((item: any) => {
      const previous = batch[batch.length - 1];
      const isContiguous = previous && item.rowNumber === previous.rowNumber + 1;

      if (batch.length && (!isContiguous || batch.length >= batchSize)) {
        batches.push(batch);
        batch = [];
      }

      batch.push(item);
    });

    if (batch.length) {
      batches.push(batch);
    }

    return batches;
  }

  private applyContiguousRowRanges(rows: number[], applyRange: (startRow: number, count: number) => void) {
    if (!rows.length) {
      return;
    }

    const sortedRows = [...rows].sort((a: number, b: number) => a - b);
    let startRow = sortedRows[0];
    let previousRow = sortedRows[0];

    for (let index = 1; index < sortedRows.length; index++) {
      const rowNumber = sortedRows[index];

      if (rowNumber !== previousRow + 1) {
        applyRange(startRow, previousRow - startRow + 1);
        startRow = rowNumber;
      }

      previousRow = rowNumber;
    }

    applyRange(startRow, previousRow - startRow + 1);
  }

  public async updateDeletedResponseMessage(sheet: any, result: any, context: any, dialogRef: any) {
    console.log('Updating deleted response message with result:', result);
    let processedCount = 0;
    const total = result?.length || 0;

    result?.data?.forEach((record: any) => {
      const rowNumber = record.row;

      const range = sheet.getRange(`A${rowNumber}:E${rowNumber}`);
      range.values = [record.value];

      const clearRange = sheet.getRange(`F${rowNumber}:F${rowNumber}`);
      clearRange.clear();

      if (record.value[3] !== "Error" && record.value[1] !== "Validation Failed") {
        range.format.font.color = "#000000";
      }
      else if (record.value[3] === "Error") {
        const fullRow = sheet.getRangeByIndexes(rowNumber - 1, 6, 1, this?.headers?.length - 9);
        fullRow.format.fill.color = "#ffcecb";
      }
    });

    if (result?.deletedRows?.length > 0) {
      let rowsToDelete = result?.deletedRows;
      rowsToDelete.sort((a: any, b: any) => b - a);

      for (let rowNum of rowsToDelete) {
        let range = sheet.getRange(`A${rowNum}:XFD${rowNum}`);
        range.delete(Excel.DeleteShiftDirection.up);
      }
    }

    this.totalSelectedRowForDeletion = 0;

    await context.sync();

    // ADDED: final update to dialog
    dialogRef?.messageChild(JSON.stringify({
      deletedCount: processedCount,
      deletedTotal: total,
      message: `Deleted records updated (${processedCount}/${total})`
    }));
  }

  public async updateErrorRecords(sheet: any, records: any, context: any) {
    try {
      const batchSize = environment.PAGESIZE;
      const errorColumnCount = this?.headers?.length - 9;
      const recordsByRow = (records || [])
        .map((record: any) => ({
          record,
          rowNumber: Number(record?.[record.length - 1])
        }))
        .filter((item: any) => Number.isFinite(item.rowNumber))
        .sort((a: any, b: any) => a.rowNumber - b.rowNumber);

      for (const batch of this.createContiguousRowBatches(recordsByRow, batchSize)) {
        const firstRowNumber = batch[0].rowNumber;
        const lastRowNumber = batch[batch.length - 1].rowNumber;
        const errorRange = sheet.getRangeByIndexes(firstRowNumber - 1, 6, batch.length, errorColumnCount);
        errorRange.format.fill.color = "#ecc0be";
        const range = sheet.getRange(`D${firstRowNumber}:D${lastRowNumber}`);
        range.format.font.color = '#c5261f';
      }

      await context.sync();
    }
    catch (error) {
      console.log(error)
    }
  }

  public async updatePublishedApiError(sheet: any, record: any, context: any) {
    console.log(record)
    const batchSize = environment.PAGESIZE;
    const errorColumnCount = this?.headers?.length - 9;
    const recordsByRow = (record || [])
      .map((item: any) => ({
        record: item,
        rowNumber: Number(item?.row)
      }))
      .filter((item: any) => Number.isFinite(item.rowNumber))
      .sort((a: any, b: any) => a.rowNumber - b.rowNumber);

    for (const batch of this.createContiguousRowBatches(recordsByRow, batchSize)) {
      const firstRowNumber = batch[0].rowNumber;
      const lastRowNumber = batch[batch.length - 1].rowNumber;
      const range = sheet.getRange(`A${firstRowNumber}:E${lastRowNumber}`);
      range.values = batch.map((item: any) => item.record.value);
      const clearRange = sheet.getRange(`F${firstRowNumber}:F${lastRowNumber}`);
      clearRange.clear();

      const successfulRows: number[] = [];
      const errorRows: number[] = [];
      const validationFailedRows: number[] = [];

      batch.forEach((item: any) => {
        const value = item.record.value;

        if (value[3] !== "Error" && value[1] !== "Validation Failed") {
          successfulRows.push(item.rowNumber);
        }
        else if (value[3] === "Error") {
          errorRows.push(item.rowNumber);
        }
        else {
          validationFailedRows.push(item.rowNumber);
        }
      });

      this.applyContiguousRowRanges(successfulRows, (startRow: number, count: number) => {
        sheet.getRange(`A${startRow}:E${startRow + count - 1}`).format.font.color = "#000000";
      });

      this.applyContiguousRowRanges(errorRows, (startRow: number, count: number) => {
        sheet.getRangeByIndexes(startRow - 1, 6, count, errorColumnCount).format.fill.color = "#ffcecb";
        sheet.getRange(`D${startRow}:D${startRow + count - 1}`).format.font.color = "#c5261f";
      });

      this.applyContiguousRowRanges(validationFailedRows, (startRow: number, count: number) => {
        sheet.getRange(`B${startRow}:C${startRow + count - 1}`).format.font.color = "#c5261f";
      });
    }

    await context.sync();
  }

  private openDialogWithFallback(path: string, options: any, onSuccess: (dialog: any) => void) {
    const tryOpen = (baseUrl: string, allowHttpFallback: boolean) => {
      Office.context.ui.displayDialogAsync(
        `${baseUrl}${path}`,
        options,
        (asyncResult: any) => {
          if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
            onSuccess(asyncResult.value);
            return;
          }

          const isLocalHttps = /^https:\/\/localhost/i.test(baseUrl);
          if (allowHttpFallback && isLocalHttps) {
            tryOpen(baseUrl.replace(/^https:/i, 'http:'), false);
            return;
          }

          this.loading = false;
          this.overLay = false;
          this.contentName = '';
          this.message = {
            message: `Unable to open loader dialog. ${asyncResult?.error?.message || 'Please check add-in URL/certificate configuration.'}`,
            type: 'error'
          };
          this.cd.detectChanges();
          this.clearMessage();
        }
      );
    };

    tryOpen(environment.URL, true);
  }
  checkNetwork() {
    this.entityId = this.selectedEntity.id;
    this.networkSubscription = this.networkService.isOnline.subscribe(isOnline => {
      if (!isOnline) {
        this.reloadRequired = true;
        this.subscription$.next();
        if (!!this.currentDialog) {
          this.currentDialog.close();
        }
        setTimeout(() => {
          this.handleOfflineDialog();
        }, 500);
      }
    })
  }
  public async validateOrPublishRecords(type?: any): Promise<any> {
    await this.indexeddbService.ensureDbOpen();
    this.checkNetwork();
    this.disablePublishButton = true;
    if (type == 'validate' && this.roleChanged && !this.sheetLoaded[this.entity?.displayName.trim().replace(/\s+/g, "")] && this.existingSheets.includes(this.entity.displayName)) {
      this.checkSheetPermission()
    }
    else {
      this.updatedData = null;
      this.isCodeNull = false;
      this.loading = true;
      this.overLay = true;
      this.contentName = 'Loading Batches...'
      await this.safeExcelRun(async (context: any) => {
        return new Promise<void>(async (resolve, reject) => {
          try {
            const sheet = context.workbook.worksheets.getActiveWorksheet();
            if (this.onChangedEventHandler) {
              await this.removeEventHandler();
            }

            const preTable = context.workbook.tables.getItem(this.tableName);

            // Convert the table to a range
            preTable.convertToRange();
            this.headers = [];
            const settings = context.workbook.settings;

            // let table = sheet.tables.getItem(this.tableName);
            const entityMetaData = settings.getItem(this.tableName);
            entityMetaData.load("value");
            // const headerRowRange = table.getHeaderRowRange();
            // headerRowRange.load("values");

            // Load the rowCount and columnCount properties of the table
            const usedRange = sheet.getUsedRange();
            usedRange.load('rowCount, columnCount');

            // const comments = sheet.comments;
            // Loop through all comments to find if there's one for the specific cell
            // comments.load("items");

            await context.sync();

            const data = await this.resolveEntityMetadata(context, settings, this.tableName, entityMetaData.value);
            this.entityId = data?.entity_id;
            this.domainAttributesArray = data?.attributeNamesToReplaceCodeWithId;
            this.headers = data?.tableHeaders;

            const rowCount = usedRange.rowCount;
            const columnCount = usedRange.columnCount;
            const pageSize = type === 'publish' ? environment.PUBLISHRECORD : 1000; // Number of rows to load at a time
            let startRow = 0;
            let totalBatchPublish = Math.ceil(rowCount / pageSize);
            let index = 1;
            let record: any = null;

            const currentRange = sheet.getRangeByIndexes(startRow + 1, 0, rowCount, columnCount); // +1 to skip header
            currentRange.load("values");
            await context.sync();
            while (startRow < rowCount) {
              if (this.reloadRequired == true) {
                break;
              }
              const values = [...currentRange.values].splice(startRow, pageSize);
              if (values.length > 0) {
                const result = await this.formatEditData(values);
                const items = result.editRecords;
                const deleteRecord = result.deletedRecords;
                if (items.length > 0 || deleteRecord.length > 0) {
                  if (type === 'publish') {
                    this.contentName = `Publishing changes batch ${index} of ${totalBatchPublish}...`;
                    record = await this.updateEntityRecords(items, deleteRecord, sheet, context, startRow);
                    if (!!record) {
                      await this.updateCellWithStatus(sheet, record, context, 'changed');
                    }
                  }
                  else {
                    this.contentName = `Validating changes batch ${index} of ${totalBatchPublish}...`;
                    const { entityData } = await this.getAllValidationRules(items, index);
                    record = entityData;
                    if (!!record) {
                      await this.updateCellWithStatus(sheet, record, context);
                    }
                  }
                }
                startRow += pageSize;
                index++;
              }
              if (startRow >= rowCount && !this.reloadRequired) {
                // if (!record) {
                this.loading = false;
                this.overLay = false
                // }
                // else {
                await this.convertSheetToTable(sheet, context, usedRange);
                // }
                break;
              }
            }
            resolve();
            return this.editRecords;
          }
          catch (error) {
            reject(error);
            if (!!this.currentDialog) {
              this.currentDialog.close()
            }
            clearInterval(this.intervalId);
            this.disablePublishButton = false;
            this.cd.detectChanges();
          }
        });
      }).catch((error: any) => {
        console.error(error, 'error');
      });
    }
  }

  public updateEntityInBluk(data: any, _deletedIds: any, sheet: any): Promise<any> {
    return new Promise((resolve) => {
      combineLatest([
        this.entityService.updateEntityDataINBulk(this.entityId, data).pipe(
          takeUntil(this.subscription$)
        ),
        // deletedIds.length > 0 ? this.entityService.deleteEntityDataINBulk(this.entityId, deletedIds).pipe(
        //   takeUntil(this.subscription$)
        // ) : ''
      ]).subscribe(
        ([entityData]) => {
          resolve({
            entityData
          });
        },
        (err: any) => {
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          if (err.status === 400) {
            console.log(err, ' input')
            if (err?.error?.message) {
              const errors = JSON.parse(err?.error?.message) || [];
              if (errors) {
                this.errorMessageHandler(errors, sheet);
              }
            }
          }
          // this.loading = false;
          // this.overLay = false
          resolve({
            entityData: null
          });
        }
      );
    });
  }

  public async errorMessageHandler(items: any, sheet: any) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const cellAddress = `D${item.__ROW_IDENTIFIER}`;
      let inputMessageField = sheet.getRange(`E${item.__ROW_IDENTIFIER}`);
      let inputValue = sheet.getRange(cellAddress);
      const inputStatus = 'Error';
      inputValue.values = [[inputStatus]];
      const errorRange = sheet.getRange("A" + item.__ROW_IDENTIFIER + ":XFD" + item.__ROW_IDENTIFIER);
      errorRange.getUsedRange().format.fill.color = "#ecc0be";
      // find the row with rowidentifier and then reasign the values
      inputMessageField.values = [[item.message]];
    }
  }

  public async updateEntityRecords(record: any, deleteRecord: any, sheet: any, _context: any, _startRow: any): Promise<any> {
    if (this.isCodeNull) {
      this.currentDialog.close();
      setTimeout(() => {
        Office.context.ui.displayDialogAsync(
          `${environment.URL}/#/missing/cell`, { height: 25, width: 20 },
          (asyncResult: any) => {
            const dialog = asyncResult.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, () => {
              dialog.close();
              this.overLay = false
            })
          }
        );
      }, 500);
      return false;
    }

    if (record.length > 0 && !this.isCodeNull) {
      this.editRecords = await this.updateDomainAttributeFields(record);
      const attributeNames = this.headers
        .filter((elm: any) => elm.totalElements > this.totalElementLimit)
        .map((elm: any) => elm.selectColumn);

      let data = this.editRecords;
      data = attributeNames.length > 0 ? { data, attributeNamesToReplaceCodeWithId: attributeNames } : { data };
      const { entityData } = await this.updateEntityInBluk(data, deleteRecord, sheet);
      return entityData;
    }
  }

  public async getAllValidationRules(record: any, vIndex: any): Promise<any> {
    const updatedRecords = await this.updateDomainAttributeFields(record)
    return new Promise((resolve) => {
      this.entityService.getValidationRules(this.entityId, updatedRecords, vIndex).subscribe(
        (entityData: any) => {
          resolve({
            entityData,
          });
        },
        (err: any) => {
          if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['/landing']);
          }
          if (err?.error?.errorCode === "VEX-400") {
            !!this.currentDialog ? this.currentDialog.close() : '';
            setTimeout(() => {
              this.handleMismatchVersionDialog(err?.error?.message);
            }, 500);
          }
          resolve({
            entityData: [],
          });
        }
      );
    });
  }

  public async formatEditData(data: any): Promise<any> {
    const lowercasedHeaderData = [this.headers.map((el: any) => { return el.selectColumn })];
    const editedRowsData = data.filter((el: any) => ['Deleted', 'Changed', 'New Row'].includes(el[3]));
    let finalData = this.combineHeaderAndData(lowercasedHeaderData, editedRowsData);
    finalData = finalData?.map((el: any) => ({
      ...el,
      id: !['', null, undefined].includes(el?.id) ? el.id : 0,
      comment: null
    }));
    this.editRecords = finalData;
    this.editRecords = this.editRecords.map((item: any) => {
      const newItem = { ...item };
      for (const [key, value] of Object.entries(newItem)) {
        const item = this.headers.find((elm: any) => elm.selectColumn === key);
        if (['#NAME?', '#N/A'].includes(newItem[key]) || (!!item && item.selectColumn !== 'id') && (item?.autoGenerated && !value)) {
          newItem[key] = null;
        }
        if (item?.selectColumn == "code" && !item?.autoGenerated && [null, "", undefined].includes(newItem[key])) {
          this.isCodeNull = true
        }

      }
      return newItem;
    });
    // filter only deleted records
    this.deletedRecords = this.editRecords.reduce((acc: any[], el: any) => {
      if (el.inputstatus === 'Deleted') {
        acc.push(el.id);
      }
      return acc;
    }, []);
    // filter only edit records
    this.editRecords = this.editRecords.filter((el: any) => ['Changed', 'New Row'].includes(el.inputstatus));
    const result = { editRecords: this.editRecords, deletedRecords: this.deletedRecords }
    return result;
  }

  public async deleteRows(range: any) {
    if (!!this.intervalId) {
      clearInterval(this.intervalId);
    }
    if (range?.length > 0) {
      this.totalSelectedRowForDeletion = range.length;
    }
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/confirm`,
      { height: 30, width: 40 },
      (item) => {
        const dialog = item.value;
        this.currentDialog = dialog;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            if (arg?.message === 'send') {
              setTimeout(() => {
                const data = { message: `Selected ${this.totalSelectedRowForDeletion} rows will be deleted on clicking the publish button. Do you want to continue?`, yes: 'Yes', no: 'No' }
                dialog.messageChild(JSON.stringify(data));
              }, 800);
            }
            // dialog.close();
            if (arg?.message === 'continue') {
              dialog.close();
              if (range.length > 0) {
                try {
                  await Excel.run({ delayForCellEdit: true }, async (context: any) => {
                    const sheet = context.workbook.worksheets.getActiveWorksheet();
                    for (const item of range) {
                      const cellAddress = `D${item}:D${item}`;
                      var inputFieldRange = sheet.getRange(cellAddress);
                      inputFieldRange.values = [["Deleted"]];
                      const row = sheet.getRange(`${item}:${item}`);
                      row.getUsedRange().format.fill.color = "#ffcecb";
                      this.deletionRowRange = null;
                      hasChangedRow = true;
                    }
                    await context.sync();
                    if (this.disablePublishButton == true) {
                      this.addPublishStatus(context, false);
                    }
                  });
                } catch (err: any) {
                  console.error('Delete rows error:', err?.message || err);
                }
              }
            }
            if (arg?.message === 'close') {
              dialog.close();
            }
          });
      });
  }

  public HandleSearchModel(text: any) {
    this.filteredModelList = this.modelList.filter((item: any) => {
      return item.displayName
        .trim()
        .toLowerCase()
        .includes(text.trim().toLowerCase());
    });
  }

  // Handle this function for adding the details in office settings.
  public async addEntityMetaData(filter: any, entity: any, currentSheetPermission: any) {
    await this.safeExcelRun(async (context: any) => {
      const settings = context.workbook.settings;
      // const range = settings.getItemOrNullObject(`Entity_${this.selectedEntity.id}`);
      const sheetName = this.handleSheetName(entity?.displayName);
      const tableName = `Entity_${this.selectedEntity?.id}`;
      const permissions = Array.isArray(currentSheetPermission) ? currentSheetPermission : [];
      const permissionChunkCount = Math.ceil(permissions.length / this.permissionSettingChunkSize);
      const jsonObject = {
        sheetName: sheetName,
        selectedEntity: entity,
        filter: filter,
        entity_id: entity?.id,
        tableHeaders: this.headers,
        query: this.query,
        selectedHeaders: this.selectedHeaders,
        attributeNamesToReplaceCodeWithId: this.domainAttributesArray,
        visibleHeaders: this.visibleHeaders,
        readColumns: this.readColumns,
        autoColumns: this.autoColumns,
        currentSheetPermissionChunkCount: permissionChunkCount,
        currentSheetPermissionChunkSize: this.permissionSettingChunkSize
      };
      const serializedMetadata = JSON.stringify(jsonObject);
      const metadataChunkCount = Math.ceil(serializedMetadata.length / this.metadataSettingChunkSize);
      settings.add(tableName, JSON.stringify({
        chunkedMetadata: true,
        chunkCount: metadataChunkCount,
        version: 2
      }));
      for (let chunkIndex = 0; chunkIndex < metadataChunkCount; chunkIndex++) {
        const chunkStart = chunkIndex * this.metadataSettingChunkSize;
        settings.add(
          `${tableName}_metadata_${chunkIndex}`,
          serializedMetadata.slice(chunkStart, chunkStart + this.metadataSettingChunkSize)
        );
      }
      for (let chunkIndex = 0; chunkIndex < permissionChunkCount; chunkIndex++) {
        const chunkStart = chunkIndex * this.permissionSettingChunkSize;
        settings.add(
          `${tableName}_permissions_${chunkIndex}`,
          JSON.stringify(permissions.slice(chunkStart, chunkStart + this.permissionSettingChunkSize))
        );
      }
      await context.sync();
      this.entityMetadataCache.set(tableName, jsonObject);
      this.sheetPermissionCache.set(tableName, permissions);
      console.log(`Entity metadata for ${entity?.displayName} added to settings.`);
    });
  }

  public flattenObject(obj: any) {
    let flattened: any = {};
    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        flattened[key] = JSON.stringify(obj[key]); // Convert array to JSON string
      } else {
        flattened[key] = obj[key];
      }
    }
    return flattened;
  }

  public restoreObject(flattened: any) {
    const restored: any = {};
    for (const key in flattened) {
      if (flattened.hasOwnProperty(key)) {
        try {
          restored[key] = JSON.parse(flattened[key]); // Convert JSON string back to array/object
        } catch (e) {
          restored[key] = flattened[key]; // If not a JSON string, use the original value
        }
      }
    }
    return restored;
  }

  public async currentSheetMetaData(entity: any) {
    await this.safeExcelRun(async (context: any) => {
      this.headers = [];
      // Get the worksheet
      const settings = context.workbook.settings;

      // Sync the context to execute the queued commands
      // await context.sync();
      if (!!entity?.id) {
        const range = settings.getItemOrNullObject(`Entity_${entity.id}`);
        range.load("isNullObject");
        await context.sync();
        if (!range.isNullObject) {
          range.load("value");
          await context.sync();
          this.entityMetaData = await this.resolveEntityMetadata(
            context,
            settings,
            `Entity_${entity.id}`,
            range.value
          );
          if (!!this.entityMetaData) {
            this.entityId = this.entityMetaData?.entity_id || null;
            this.headers = this.entityMetaData?.tableHeaders ?? [];
            this.query = this.entityMetaData?.query;
            this.previousQuery = this.entityMetaData?.query;
            this.filter = this.entityMetaData?.filter ?? [];
            this.domainAttributesArray = this.entityMetaData?.attributeNamesToReplaceCodeWithId ?? [];
            this.selectedHeaders = this.normalizeSelectedColumnNames(this.entityMetaData?.selectedHeaders ?? []);
            this.selectedEntity = this.entityMetaData?.selectedEntity;
            this.showFilter = true;
            this.visibleHeaders = this.entityMetaData?.visibleHeaders ?? [];
            this.cd.detectChanges();
          }
        }
        else {
          this.filter = []
          this.selectedHeaders = []
          this.query = null;
          this.previousQuery = null;
          this.isUpdate = false;
        }
      }
    });
  }

  public async getCurrentTableName(existingContext?: any) {
    const runWithContext = async (context: any) => {
      var sheet = context.workbook.worksheets.getActiveWorksheet();
      // Load the collection of tables in the active worksheet
      const tables = sheet.tables;
      tables.load("items/name");

      // Sync the context to execute the queued commands
      await context.sync();

      if (tables?.items?.length > 0) {
        let tableNames = tables.items[0].name;
        this.tableName = tableNames;
        return tableNames;
      }
      return true;
    };

    if (existingContext) {
      return await runWithContext(existingContext);
    }
    await this.safeExcelRun(runWithContext);
  }

  ngOnDestroy(): void {
    this.subscription$.next();
    clearInterval(this.intervalId);
    this.unsubscribeNetwork();
    window.location.reload();
  }
  private unsubscribeNetwork() {
    if (this.networkSubscription) {
      this.networkSubscription.unsubscribe();
      this.networkSubscription = null;
    }
  }

  private async writeValidationResultsInBatches(
    sheet: any,
    context: any,
    startRow: number,
    statuses: any[][],
    messages: any[][],
    onBatchWritten?: (processedRows: number, totalRows: number) => void
  ): Promise<void> {
    for (let offset = 0; offset < statuses.length; offset += this.validationExcelWriteBatchSize) {
      const rowCount = Math.min(this.validationExcelWriteBatchSize, statuses.length - offset);
      const batchStartRow = startRow + offset;
      const batchEndRow = batchStartRow + rowCount - 1;

      sheet.getRange(`D${batchStartRow}:D${batchEndRow}`).values = statuses.slice(offset, offset + rowCount);
      sheet.getRange(`E${batchStartRow}:E${batchEndRow}`).values = messages.slice(offset, offset + rowCount);
      onBatchWritten?.(offset, statuses.length);
      await context.sync();
      onBatchWritten?.(offset + rowCount, statuses.length);
    }
  }

  private createValidationFormatBatch(): ValidationFormatBatch {
    return {
      errorStatusRows: new Set<number>(),
      validStatusRows: new Set<number>(),
      invalidCellAddresses: new Set<string>()
    };
  }

  private groupRowsIntoRanges(rows: Set<number>, columnLetter: string): string[] {
    const sortedRows = Array.from(rows).sort((a, b) => a - b);
    const ranges: string[] = [];
    let start: number | undefined;
    let previous: number | undefined;

    for (const row of sortedRows) {
      if (start === undefined) {
        start = previous = row;
      } else if (row === (previous as number) + 1) {
        previous = row;
      } else {
        ranges.push(start === previous ? `${columnLetter}${start}` : `${columnLetter}${start}:${columnLetter}${previous}`);
        start = previous = row;
      }
    }
    if (start !== undefined) {
      ranges.push(start === previous ? `${columnLetter}${start}` : `${columnLetter}${start}:${columnLetter}${previous}`);
    }
    return ranges;
  }

  private groupCellAddresses(addresses: Set<string>): string[] {
    const rowsByColumn = new Map<string, Set<number>>();
    const existingRanges = new Set<string>();

    addresses.forEach((address) => {
      const match = address.match(/^\$?([A-Z]+)\$?(\d+)$/i);
      if (!match) {
        existingRanges.add(address);
        return;
      }
      const column = match[1].toUpperCase();
      if (!rowsByColumn.has(column)) {
        rowsByColumn.set(column, new Set<number>());
      }
      rowsByColumn.get(column)?.add(+match[2]);
    });

    rowsByColumn.forEach((rows, column) => {
      this.groupRowsIntoRanges(rows, column).forEach((rangeAddress) => existingRanges.add(rangeAddress));
    });
    return Array.from(existingRanges);
  }

  private applyGroupedRangeFormat(sheet: any, addresses: string[], format: 'errorFill' | 'errorFont' | 'validFont'): void {
    const rangeAreaSize = 200;
    for (let offset = 0; offset < addresses.length; offset += rangeAreaSize) {
      const rangeAreas = sheet.getRanges(addresses.slice(offset, offset + rangeAreaSize).join(','));
      if (format === 'errorFill') {
        rangeAreas.format.fill.color = '#ffcecb';
      } else {
        rangeAreas.format.font.color = format === 'errorFont' ? '#FF0000' : '#000000';
      }
    }
  }

  private queueValidationBatchFormatting(sheet: any, formatBatch: ValidationFormatBatch): void {
    this.applyGroupedRangeFormat(sheet, this.groupRowsIntoRanges(formatBatch.errorStatusRows, 'D'), 'errorFont');
    this.applyGroupedRangeFormat(sheet, this.groupRowsIntoRanges(formatBatch.validStatusRows, 'D'), 'validFont');
    this.applyGroupedRangeFormat(sheet, this.groupCellAddresses(formatBatch.invalidCellAddresses), 'errorFill');
  }

  private reportValidationProgress(processedRecords: number, totalRecords: number, message: string, unit = 'rows'): void {
    this.contentName = message;
    this.validationProgress = {
      totalRecords,
      processedRecords: Math.min(processedRecords, totalRecords),
      batchStatus: 'success',
      retryCount: 0,
      unit
    };

    if (this.currentDialog && typeof this.currentDialog.messageChild === 'function') {
      try {
        this.currentDialog.messageChild(JSON.stringify({
          action: 'validation',
          message,
          progress: this.validationProgress
        }));
      } catch (error) {
        console.warn('Unable to update validation progress dialog:', error);
      }
    }
    this.cd.detectChanges();
  }

  private closeValidationProgress(): void {
    if (this.currentDialog) {
      try {
        this.currentDialog.close();
      } catch (dialogCloseError) {
        console.warn('Validation dialog was already closed:', dialogCloseError);
      }
    }
    this.currentDialog = null;
    this.loading = false;
    this.overLay = false;
    this.contentName = '';
    this.validationProgress = {
      totalRecords: 0,
      processedRecords: 0,
      batchStatus: 'success',
      retryCount: 0,
      unit: 'rows'
    };
    this.cd.detectChanges();
  }

  private async restoreExcelChangeEvents(): Promise<void> {
    try {
      await Excel.run(async (recoveryContext: any) => {
        recoveryContext.runtime.enableEvents = true;
        await recoveryContext.sync();
      });
    } catch (eventRecoveryError) {
      console.error('Unable to restore Excel change events after validation:', eventRecoveryError);
    }
  }

  private async getSheetPermissions(
    context: any,
    settings: any,
    tableName: string,
    metadata: any
  ): Promise<any[]> {
    if (Array.isArray(metadata?.currentSheetPermission)) {
      return metadata.currentSheetPermission;
    }

    const cachedPermissions = this.sheetPermissionCache.get(tableName);
    if (cachedPermissions) {
      return cachedPermissions;
    }

    const chunkCount = Number(metadata?.currentSheetPermissionChunkCount || 0);
    if (chunkCount <= 0) {
      return [];
    }

    const permissionSettings: any[] = [];
    for (let chunkIndex = 0; chunkIndex < chunkCount; chunkIndex++) {
      const permissionSetting = settings.getItemOrNullObject(`${tableName}_permissions_${chunkIndex}`);
      permissionSetting.load('isNullObject');
      permissionSettings.push(permissionSetting);
    }
    await context.sync();

    permissionSettings.forEach((permissionSetting) => {
      if (!permissionSetting.isNullObject) {
        permissionSetting.load('value');
      }
    });
    await context.sync();

    const permissions = permissionSettings.flatMap((permissionSetting) => {
      if (permissionSetting.isNullObject || typeof permissionSetting.value !== 'string') {
        return [];
      }
      try {
        return JSON.parse(permissionSetting.value);
      } catch {
        return [];
      }
    });
    this.sheetPermissionCache.set(tableName, permissions);
    return permissions;
  }

  private async resolveEntityMetadata(
    context: any,
    settings: any,
    tableName: string,
    storedValue?: string
  ): Promise<any> {
    const cachedMetadata = this.entityMetadataCache.get(tableName);
    if (cachedMetadata) {
      return cachedMetadata;
    }

    let metadataValue = storedValue;
    if (metadataValue === undefined) {
      const metadataSetting = settings.getItem(tableName);
      metadataSetting.load('value');
      await context.sync();
      metadataValue = metadataSetting.value;
    }

    const manifest = JSON.parse(metadataValue as string);
    if (!manifest?.chunkedMetadata) {
      this.entityMetadataCache.set(tableName, manifest);
      return manifest;
    }

    const chunks: any[] = [];
    for (let chunkIndex = 0; chunkIndex < manifest.chunkCount; chunkIndex++) {
      const chunk = settings.getItem(`${tableName}_metadata_${chunkIndex}`);
      chunk.load('value');
      chunks.push(chunk);
    }
    await context.sync();

    const metadata = JSON.parse(chunks.map((chunk) => chunk.value).join(''));
    this.entityMetadataCache.set(tableName, metadata);
    return metadata;
  }

  private queueValidationErrorSettings(settings: any, tableName: string, errorRows: any[]): void {
    const errorStatus = { errorRows: Array.isArray(errorRows) ? errorRows : [] };
    const sortedErrors = [...errorStatus.errorRows].sort((a: any, b: any) => a.row - b.row);
    const errorRuns: any[] = [];
    for (const errorRow of sortedErrors) {
      const signature = JSON.stringify([errorRow.column, errorRow.columnName, errorRow.type]);
      const previousRun = errorRuns[errorRuns.length - 1];
      if (previousRun && previousRun.end + 1 === errorRow.row && previousRun.signature === signature) {
        previousRun.end = errorRow.row;
      } else {
        errorRuns.push({
          start: errorRow.row,
          end: errorRow.row,
          signature,
          column: errorRow.column,
          columnName: errorRow.columnName,
          type: errorRow.type
        });
      }
    }
    const serializedErrors = JSON.stringify({ format: 'rle-v1', runs: errorRuns });
    const chunkCount = Math.ceil(serializedErrors.length / this.validationErrorSettingChunkSize);
    const manifestKey = `${tableName}_error_status_v2_manifest`;

    settings.add(manifestKey, JSON.stringify({ chunkCount, version: 2 }));
    for (let chunkIndex = 0; chunkIndex < chunkCount; chunkIndex++) {
      const chunkStart = chunkIndex * this.validationErrorSettingChunkSize;
      settings.add(
        `${tableName}_error_status_v2_${chunkIndex}`,
        serializedErrors.slice(chunkStart, chunkStart + this.validationErrorSettingChunkSize)
      );
    }
    this.validationErrorCache.set(tableName, errorStatus);
  }

  private async getValidationErrorStatus(context: any, settings: any, tableName: string): Promise<any> {
    const cachedErrors = this.validationErrorCache.get(tableName);
    if (cachedErrors) {
      return cachedErrors;
    }

    const manifest = settings.getItemOrNullObject(`${tableName}_error_status_v2_manifest`);
    manifest.load('isNullObject');
    await context.sync();
    if (manifest.isNullObject) {
      const emptyErrorStatus = { errorRows: [] };
      this.validationErrorCache.set(tableName, emptyErrorStatus);
      return emptyErrorStatus;
    }

    manifest.load('value');
    await context.sync();
    const manifestValue = JSON.parse(manifest.value);
    const chunks: any[] = [];
    for (let chunkIndex = 0; chunkIndex < Number(manifestValue?.chunkCount || 0); chunkIndex++) {
      const chunk = settings.getItem(`${tableName}_error_status_v2_${chunkIndex}`);
      chunk.load('value');
      chunks.push(chunk);
    }
    await context.sync();

    const storedErrors = chunks.length > 0
      ? JSON.parse(chunks.map((chunk) => chunk.value).join(''))
      : { format: 'rle-v1', runs: [] };
    const errorStatus = storedErrors?.format === 'rle-v1'
      ? {
        errorRows: (storedErrors.runs || []).flatMap((run: any) => {
          const rows: any[] = [];
          for (let row = run.start; row <= run.end; row++) {
            rows.push({
              row,
              column: [...(run.column || [])],
              columnName: [...(run.columnName || [])],
              type: [...(run.type || [])]
            });
          }
          return rows;
        })
      }
      : storedErrors;
    this.validationErrorCache.set(tableName, errorStatus);
    return errorStatus;
  }

  public async excelChangeEvent(event: any) {
    if (event.changeType == "RowInserted" && changeDetectionEventInProgress) {
      this.insertedRow.push(event);
    }
    // Skip the change event if the cell value remains unchanged
    if (!changeDetectionEventInProgress && (event.details?.valueAfter == null || event.details.valueAfter !== 'Deleted') && (event.details === undefined || event.details?.valueAfter !== event.details?.valueBefore)) {
      changeDetectionEventInProgress = true;
      const cells = event.address.split(',');
      const changedCellAddress = event.address;
      const rowSequential = areRowsSequential(cells);
      let cellRanges: any;
      const fullRange = convertCellsToRange(event.address, rowSequential);
      if (fullRange?.length > 1) {
        cellRanges = fullRange
      }
      else {
        cellRanges = event.address.split(":");
      }
      await this.indexeddbService.ensureDbOpen();
      let firstLetter: any;
      let secondLetter: any;
      let rangeArray: any = [];
      let changedIndex: number;

      let changeRange: any;
      let changedColumnIndices: any = []

      if (cellRanges.length === 2 && rowSequential) {
        firstLetter = cellRanges[0].match(/([A-Z]+)(\d+)/);
        secondLetter = cellRanges[1].match(/([A-Z]+)(\d+)/);
        rangeArray = generateRange(+firstLetter[2], +secondLetter[2]);
        changedIndex = secondLetter[1] ?
          this.columnIndexFromLetter(secondLetter[1]) : this.columnIndexFromLetter(firstLetter[1]);
        changeRange = `F${firstLetter[2]}:F${secondLetter[2]}`;
        changedColumnIndices = this.appUtilityService.indicesFromLetterToLetter(firstLetter[1], secondLetter[1]);
      }
      else {
        changedIndex = this.findLargestColumnIndex(event.address);
        if (rowSequential) {
          changeRange = `F${cellRanges[0].replace(/\D/g, '')}`;
          changedColumnIndices = [changedIndex - 1];
        }
      }
      const validationTotalRows = rowSequential
        ? rangeArray.length
        : cellRanges.reduce((total: number, address: string) => {
          const rows = parseRowNumbers(address);
          if (!rows || rows.length < 2) {
            return total + 1;
          }
          return total + Math.abs(+rows[1] - +rows[0]) + 1;
        }, 0);
      let validationProcessedRows = 0;
      this.validationProgress = {
        totalRecords: validationTotalRows,
        processedRecords: 0,
        batchStatus: 'success',
        retryCount: 0,
        unit: 'rows'
      };
      var match = changedCellAddress.match(/([A-Z]+)(\d+)/);
      var columnLetter = match[1];
      var rowNumber = parseInt(match[2]);
      try {
        await Excel.run({ delayForCellEdit: true }, async (context: any) => {
          try {
            if (!["D", "B", "C", "E", "A", "F"].includes(columnLetter) && validationTotalRows > this.environment?.VALIDATIONPOPUPLENGTH) {
              this.loading = true;
              this.overLay = true;
              this.contentName = 'Data validation is in progress.';
              this.cd.detectChanges();

              // Handle this when any change in excel then loader showing
              Office.context.ui.displayDialogAsync(
                `${environment.URL}/#/loader`, { height: 50, width: 60 },
                (asyncResult: any) => {
                  const dialog = asyncResult.value;
                  this.currentDialog = dialog;
                  dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
                    if (arg?.message === 'start') {
                      setTimeout(() => {
                        this.reportValidationProgress(0, validationTotalRows, 'Preparing data validation...');
                      }, 800);
                    }
                  })
                }
              );
            }
            let entityMetaData: any;
            let failedValidationRows: any;
            context.runtime.enableEvents = false;
            this.reportValidationProgress(0, validationTotalRows, 'Reading changed worksheet data...');
            await context.sync();
            // getting all meta data
            const settings = context.workbook.settings;
            await this.getCurrentTableName(context);
            if (!!this.tableName) {
              // Entity metadata must exist for the active table. Validation errors use chunked settings.
              entityMetaData = settings.getItem(this.tableName);
              entityMetaData.load("value");
            }
            var sheet = context.workbook.worksheets.getActiveWorksheet();
            let inputValue = sheet.getRange(`D${rowNumber}`);
            let inputMessgeValue = sheet.getRange(`E${rowNumber}`);
            let currentLookupData: any;
            const lookupValidationCache = new Map<string, Map<any, Set<any>>>();
            const getLookupValidationIndex = async (header: any): Promise<Map<any, Set<any>> | undefined> => {
              if (!header?.referencedTableId || header?.totalElements >= this.totalElementLimit) {
                return undefined;
              }

              const lookupId = header.referencedTableId.toString();
              let lookupIndex = lookupValidationCache.get(lookupId);
              if (!lookupIndex) {
                this.reportValidationProgress(validationProcessedRows, validationTotalRows, 'Preparing lookup validation data...');
                const lookupData = await this.indexeddbService.getAllData('Lookup_' + header.referencedTableId);
                lookupIndex = this.createLookupValidationIndex(lookupData);
                lookupValidationCache.set(lookupId, lookupIndex);
              }
              return lookupIndex;
            };

            const usedRange = sheet.getUsedRange();
            usedRange.load('rowCount, columnCount');


            const changedRange = sheet.getRange(changeRange);
            range = changedRange;
            changedRange.load(["values", "rowIndex"]);

            await context.sync();
            if (event?.changeType === 'RangeEdited'
              && !["D", "B", "C", "E", "A", "F"].includes(columnLetter)
              && changedIndex < this.currentSheetHeaders?.length
              && rowSequential
              && range.rowIndex !== 0) {
              this.addToChangeColumn(changedRange.values, changedColumnIndices, context, range);
            }
            const data = await this.resolveEntityMetadata(context, settings, this.tableName, entityMetaData?.value);
            failedValidationRows = await this.getValidationErrorStatus(context, settings, this.tableName);
            const failedValidationRowMap = new Map<any, any>(
              (failedValidationRows?.errorRows || []).map((errorRow: any) => [errorRow.row, errorRow])
            );
            const currentSheetPermission = await this.getSheetPermissions(context, settings, this.tableName, data);
            const readPermissionData = currentSheetPermission?.findIndex((el: any) => ['READ', 'DENY'].includes(el));
            this.currentSheetHeaders = data?.tableHeaders || this.currentSheetHeaders;
            const headerItem = this.currentSheetHeaders[changedIndex - 1];
            if (!!headerItem?.referencedTableId && headerItem?.totalElements < this.totalElementLimit) {
              currentLookupData = await getLookupValidationIndex(headerItem);
            }

            let rowCount = usedRange.rowCount;
            let inputStatus: any;
            let idColumnVal: any;
            if (!!rowCount) {
              const rowRange = sheet.getRangeByIndexes(rowNumber - 1, 0, 1, usedRange.columnCount);
              rowRange.load('values');
              await context.sync();
              inputStatus = rowRange.values[0][3];
              idColumnVal = rowRange.values[0][0];
            }

            if (!!event?.details && event?.details?.valueAfter === event?.details?.valueBefore && inputStatus === 'Unchanged') {
              const currentRange = sheet.getRange(event.address);
              currentRange.format.fill.clear();
            }

            // Handle this condition when row is not sequential
            if (event?.changeType === 'RangeEdited' && cellRanges.length >= 2 && !rowSequential && changedIndex <= this.currentSheetHeaders.length) {
              for (let i = 0; i < cellRanges.length; i++) {
                const address = cellRanges[i];
                const rowNumber: any = parseRowNumbers(address);
                const cellRange = generateRange(+rowNumber[0], +rowNumber[1]);
                // Apply the edited colour once for the area; individual errors override it below.
                sheet.getRange(address).format.fill.color = "#ffd3a9";
                for (let batchStart = 0; batchStart < cellRange.length; batchStart += this.validationExcelWriteBatchSize) {
                  const batchRows = cellRange.slice(batchStart, batchStart + this.validationExcelWriteBatchSize);
                  const formatBatch = this.createValidationFormatBatch();
                  for (const row of batchRows) {
                    const permission = !!currentSheetPermission && currentSheetPermission.length > 0 ? currentSheetPermission[row - 2] : null;
                    if ((!!permission && permission !== 'UPDATE') || ["D", "B", "C", "E", "A", "F"].includes(columnLetter) || changedIndex == this.currentSheetHeaders.length) {
                      this.addColumnErrorValidations(sheet, address, 'permission', row, settings, failedValidationRows, columnLetter, headerItem?.name, false, failedValidationRowMap, formatBatch);
                    }
                    else {
                      const inputField = sheet.getRange(`D${row}`);
                      const value = inputStatus === 'Deleted' ? [['Deleted']] : inputStatus !== '' ? [['Changed']] : [['New Row']];
                      inputField.values = value;
                    }
                  }
                  this.queueValidationBatchFormatting(sheet, formatBatch);
                  await context.sync();
                  validationProcessedRows += batchRows.length;
                  this.reportValidationProgress(
                    validationProcessedRows,
                    validationTotalRows,
                    `Validating changed rows: ${validationProcessedRows.toLocaleString()} of ${validationTotalRows.toLocaleString()}`
                  );
                }
                const sortedRowNumbers = rowNumber.sort((a: number, b: number) => a - b);
                const changedRange = sheet.getRange(`F${sortedRowNumbers[0]}:F${sortedRowNumbers[1]}`);
                changedRange.load(["values", "rowIndex"]);
                await context.sync();
                const changedColumnLeters = this.appUtilityService.extractColumnLetters(address)
                changedColumnIndices = this.appUtilityService.indicesFromLetterToLetter(changedColumnLeters.firstColumn, changedColumnLeters.secondColumn);
                if (changedRange.rowIndex !== 0) {
                  this.addToChangeColumn(changedRange.values, changedColumnIndices, context, changedRange);
                }
              }
              if (this.disablePublishButton == true) {
                await this.addPublishStatus(context, false, false);
              }
              await context.sync();
            }

            if (["CellInserted", "RowInserted"].includes(event.changeType) && !event.details) {
              var range = sheet.getRange(event.address);
              let inputMessages: any = [];
              let settingsData: any;
              let status: any;
              let newCurrentLookupData: any;
              let validationMessage: any;
              let inputStatusArray: any = [];
              range.format.fill.color = "#ffd3a9";
              range.load('values');
              await context.sync();

              if (range?.values?.length > 0) {
                for (let batchStart = 0; batchStart < range.values.length; batchStart += this.validationRowBatchSize) {
                  const batchEnd = Math.min(batchStart + this.validationRowBatchSize, range.values.length);
                  const formatBatch = this.createValidationFormatBatch();
                  for (let rowIndex = batchStart; rowIndex < batchEnd; rowIndex++) {
                    const item = range.values[rowIndex];
                    // Handle this with looping and checking column values
                    for (let columnIndex = 0; columnIndex < item?.length; columnIndex++) {
                      const value = item[columnIndex];
                      const lastColumn = item[item.length - 1];
                      // If value is not blank
                      if (!["", null, undefined].includes(value) && value !== lastColumn) {
                        const headerValue = this.headers[columnIndex];
                        // If column is domain based
                        if (!!headerValue?.referencedTableId && headerValue?.totalElements < this.totalElementLimit) {
                          newCurrentLookupData = await getLookupValidationIndex(headerValue);
                        }
                        const valueMatch = this.matchColumnValuesWithValidation(headerValue, value, newCurrentLookupData);
                        // When value is not matched
                        if (!valueMatch || headerValue?.autoGenerated || headerValue?.permission !== 'UPDATE') {
                          const columnLetter = ExcelHelper.getColumnLetter(columnIndex);
                          const address = `${columnLetter}${rangeArray[rowIndex]}`;
                          const message = (headerValue?.autoGenerated || headerValue?.permission !== 'UPDATE') ? 'permission' : 'validation';
                          const result: any = this.addColumnErrorValidations(sheet, address, message, rangeArray[rowIndex], settings, failedValidationRows, columnLetter, headerValue?.name, false, failedValidationRowMap, formatBatch);
                          settingsData = result.error;
                          validationMessage = [result.message];
                          status = ['Error'];
                        }
                      }
                    }
                    const values = inputStatus === 'Deleted' ? ['Deleted'] : inputStatus !== '' ? ['Changed'] : ['New Row'];
                    const val = !!status ? status : values;
                    const msg = !!validationMessage ? validationMessage : [''];
                    inputStatusArray.push(val);
                    inputMessages.push(msg);
                  }

                  this.queueValidationBatchFormatting(sheet, formatBatch);
                  await this.writeValidationResultsInBatches(
                    sheet,
                    context,
                    +firstLetter[2] + batchStart,
                    inputStatusArray.slice(batchStart, batchEnd),
                    inputMessages.slice(batchStart, batchEnd),
                    (writtenRows) => this.reportValidationProgress(
                      batchStart + writtenRows,
                      range.values.length,
                      `Applying validation results: ${(batchStart + writtenRows).toLocaleString()} of ${range.values.length.toLocaleString()} rows`
                    )
                  );
                }
                // Handle this when add settings in loop
                settingsData = settingsData?.__zone_symbol__value ?? settingsData;
                this.queueValidationErrorSettings(settings, this.tableName, settingsData);

                for (let headerIndex = 0; headerIndex < this.headers?.length; headerIndex++) {
                  const header = this.headers[headerIndex];
                  const colLetter = ExcelHelper.getColumnLetter(headerIndex);
                  if ((!!header?.permission && header?.permission !== 'UPDATE' || header?.autoGenerated || header?.systemAttribute) && !["D", "B", "C", "E", "A", "F"].includes(colLetter)) {
                    const readCol = sheet.getRange(`${colLetter}:${colLetter}`);
                    readCol.format.fill.color = "#c5c5c5";
                  }
                }

                if (this.disablePublishButton == true) {
                  await this.addPublishStatus(context, false, false);
                }

              }
            }

            if (['CellDeleted', 'ColumnDeleted'].includes(event.changeType) || event.changeType == 'RangeEdited' && !event.details) {
              await context.sync();
            }

            if (event?.changeType === 'RangeEdited' && !!firstLetter && !!secondLetter && changedIndex <= this.currentSheetHeaders.length) {
              const range = sheet.getRange(event.address)
              let settingsData: any;
              let inputMessages: any = [];
              let status: any = [];
              let totalRows: number = 0;
              let columnRange = extractColumnsFromRange(changedCellAddress);
              const idColumn = sheet.getRange(`A${firstLetter[2]}:A${secondLetter[2]}`);
              idColumn.load("values");
              range.load('values');
              const cellAddress = `D${firstLetter[2]}:D${secondLetter[2]}`;
              const inputFieldRange = sheet.getRange(cellAddress);
              const inputMessageField = sheet.getRange(`E${firstLetter[2]}:E${secondLetter[2]}`);
              const rowRange = sheet.getRange(event.address);
              rowRange.format.fill.color = "#ffd3a9";
              inputFieldRange.load('values');
              inputMessageField.load('values');
              await context.sync();
              try {
                // Handle this function when drag the values
                if (readPermissionData === -1 && !["D", "B", "C", "E", "A", "F"].includes(columnLetter)) {
                  const columnValues = range.values;
                  totalRows = columnValues.length;

                  for (let columnInx = 0; columnInx < changedColumnIndices.length; columnInx++) {
                    columnLetter = columnRange[columnInx];
                    const colIndex = changedColumnIndices[columnInx];
                    const values = columnValues.map((val: any) => val[columnInx]);
                    const headerItem = this.currentSheetHeaders[colIndex];
                    if (!!headerItem?.referencedTableId && headerItem?.totalElements < this.totalElementLimit) {
                      currentLookupData = await getLookupValidationIndex(headerItem);
                    }

                    // Handle column validation and row status checked
                    for (let batchStart = 0; batchStart < values.length; batchStart += this.validationRowBatchSize) {
                      const batchEnd = Math.min(batchStart + this.validationRowBatchSize, values.length);
                      const formatBatch = this.createValidationFormatBatch();
                      for (let i = batchStart; i < batchEnd; i++) {
                        const row = rangeArray[i];
                        const address = columnLetter + row;
                        const value = values[i];
                        let inputStatusVal = inputFieldRange.values[i][0];
                        let idColumnVal = idColumn.values[i][0];

                        // Handle this when data validation matched
                        const valueMatch = this.matchColumnValuesWithValidation(headerItem, value, currentLookupData);
                        let validationFailedRowByIndex = failedValidationRowMap.has(row) ? 0 : -1;
                        let columnRow = failedValidationRowMap.get(row)?.column?.includes(columnLetter)
                          ? failedValidationRowMap.get(row)
                          : undefined;
                        let permission = !!currentSheetPermission && currentSheetPermission.length > 0 ? currentSheetPermission[row - 2] : null;
                        permission = !permission || permission === 'UPDATE' ? headerItem?.permission : permission;
                        if ((!!permission && permission !== 'UPDATE') || ["D", "B", "C", "E", "A", "F"].includes(columnLetter) || changedIndex == this.currentSheetHeaders.length) {
                        // Handle this function when did't have permission to update
                        const message = (headerItem?.autoGenerated || headerItem?.permission !== 'UPDATE') ? 'permission' : 'validation';
                        let result: any = this.addColumnErrorValidations(sheet, address, message, row, settings, failedValidationRows, columnLetter, headerItem?.name, false, failedValidationRowMap, formatBatch);
                        result = result?.__zone_symbol__value ?? result;
                        settingsData = result.error;
                        inputMessages.push([result.message]);
                        status.push(['Error']);
                      }
                      else {
                        if (!!valueMatch && (validationFailedRowByIndex !== -1 && !!columnRow)) {
                          // Handle this for remove that particular row and column from the settings
                          const item: any = this.updateSettings(sheet, settings, failedValidationRows, row, columnLetter, headerItem?.name, false, failedValidationRowMap);
                          validationFailedRowByIndex = item.errorRowByIndex;
                          settingsData = item.errorStatus;
                          validationFailedRowByIndex !== -1 ? status.push(['Error']) : '';
                        }
                        // Handle this when data validation failed
                        if (!valueMatch || headerItem?.autoGenerated) {
                          const message = (headerItem?.autoGenerated || headerItem?.permission !== 'UPDATE') ? 'permission' : 'validation';
                          let result: any = this.addColumnErrorValidations(sheet, address, message, row, settings, failedValidationRows, columnLetter, headerItem?.name, false, failedValidationRowMap, formatBatch);
                          result = result?.__zone_symbol__value ?? result;
                          settingsData = result.error;
                          inputMessages.push([result.message]);
                          status.push(['Error']);
                        }
                        else if (validationFailedRowByIndex === -1 && !headerItem?.autoGenerated) {
                          inputMessages.push(['']);
                          const values = inputStatusVal === 'Deleted' ? ['Deleted'] : (inputStatusVal === 'New Row' || idColumnVal === '') ? ['New Row'] : ['Changed'];
                          status.push(values);
                          formatBatch.validStatusRows.add(+row);
                        }
                        else if (!!valueMatch && validationFailedRowByIndex !== -1 && !columnRow) {
                          const permissionMsg = '- This attribute is read only. You do not have permission to update this attribute';
                          const validationMsg = '- This attribute is not valid.';
                          const message = failedValidationRows?.errorRows[validationFailedRowByIndex]?.columnName?.map((colName: any, index: number) => (failedValidationRows?.errorRows[validationFailedRowByIndex]?.type[index] === 'permission') ? `${colName} ${permissionMsg}` : `${colName} ${validationMsg}`).join('\n');
                          inputMessages.push([message]);
                          status.push(['Error']);
                        }
                        }
                      }
                      const processedCells = (columnInx * values.length) + batchEnd;
                      const totalCells = values.length * changedColumnIndices.length;
                      this.queueValidationBatchFormatting(sheet, formatBatch);
                      this.reportValidationProgress(
                        (columnInx * values.length) + batchStart,
                        totalCells,
                        `Applying validation formatting for rows ${(batchStart + 1).toLocaleString()}-${batchEnd.toLocaleString()}...`,
                        'cells'
                      );
                      await context.sync();
                      this.reportValidationProgress(
                        processedCells,
                        totalCells,
                        `Validating changed cells: ${processedCells.toLocaleString()} of ${totalCells.toLocaleString()}`,
                        'cells'
                      );
                      // Yield briefly so the dialog can render progress between CPU-heavy batches.
                      await new Promise<void>((resolve) => setTimeout(resolve, 0));
                    };
                  };
                }
                else {
                  const columnValues = range.values;
                  totalRows = columnValues.length;
                  for (let batchStart = 0; batchStart < rangeArray.length; batchStart += this.validationRowBatchSize) {
                    const batchEnd = Math.min(batchStart + this.validationRowBatchSize, rangeArray.length);
                    const formatBatch = this.createValidationFormatBatch();
                    for (let i = batchStart; i < batchEnd; i++) {
                      const row = rangeArray[i];
                      let idColumnVal = idColumn.values[i][0];
                      const permission = !!currentSheetPermission && currentSheetPermission.length > 0 ? currentSheetPermission[row - 2] : null;
                      if ((!!permission && permission !== 'UPDATE') || ["D", "B", "C", "E", "A", "F"].includes(columnLetter) || changedIndex == this.currentSheetHeaders.length) {
                        // Handle this function when did't have permission to update
                        const address = columnLetter + row;
                        const result: any = this.addColumnErrorValidations(sheet, address, 'permission', row, settings, failedValidationRows, columnLetter, headerItem?.name, false, failedValidationRowMap, formatBatch);
                        settingsData = result.error;
                        inputMessages.push([result.message]);
                        status.push(['Error']);
                      }
                      else {
                        const values = inputStatus === 'Deleted' ? ['Deleted'] : (inputStatus === 'New Row' || idColumnVal === '') ? ['New Row'] : ['Changed'];
                        status.push(values);
                        inputMessages.push(['']);
                        formatBatch.validStatusRows.add(+row);
                      }
                    }
                    this.queueValidationBatchFormatting(sheet, formatBatch);
                    this.reportValidationProgress(
                      batchStart,
                      rangeArray.length,
                      `Applying permission formatting for rows ${(batchStart + 1).toLocaleString()}-${batchEnd.toLocaleString()}...`
                    );
                    await context.sync();
                    this.reportValidationProgress(
                      batchEnd,
                      rangeArray.length,
                      `Checking row permissions: ${batchEnd.toLocaleString()} of ${rangeArray.length.toLocaleString()}`
                    );
                    await new Promise<void>((resolve) => setTimeout(resolve, 0));
                  }
                }
                // Handle this when add settings in loop
                if (!!settingsData) {
                  settingsData = settingsData?.__zone_symbol__value ?? settingsData;
                  this.queueValidationErrorSettings(settings, this.tableName, settingsData);
                }

                const finalStatuses = status.slice(-totalRows);
                const finalMessages = inputMessages.slice(-totalRows);
                await this.writeValidationResultsInBatches(
                  sheet,
                  context,
                  +firstLetter[2],
                  finalStatuses,
                  finalMessages,
                  (writtenRows, totalRows) => this.reportValidationProgress(
                    writtenRows,
                    totalRows,
                    `Applying validation results: ${writtenRows.toLocaleString()} of ${totalRows.toLocaleString()} rows`
                  )
                );
                if (this.disablePublishButton == true) {
                  await this.addPublishStatus(context, false, false);
                }
              } catch (error) {
                console.error('Error updating cell values:', error);
              }
            }
            if (!changedCellAddress.startsWith("Sheet1!A") && !!event.details && event?.changeType === 'RangeEdited' && changedIndex <= this.currentSheetHeaders.length) {
              let permission = !!currentSheetPermission && currentSheetPermission.length > 0 ? currentSheetPermission[rowNumber - 2] : null;
              permission = !permission || permission === 'UPDATE' ? headerItem?.permission : permission;
              const currentRange = sheet.getRange(event.address);
              currentRange.format.fill.color = "#ffd3a9";
              // Handle this for domain based attribute values match.
              const valueMatch = this.matchColumnValuesWithValidation(headerItem, event?.details?.valueAfter, currentLookupData, currentRange);
              const readColumn = !!this.autoColumns ? this.autoColumns.includes(`${columnLetter}:${columnLetter}`) : null;
              if (((!!permission && permission !== 'UPDATE') || readColumn || changedIndex == this.currentSheetHeaders.length && inputStatus !== 'Deleted')) {
                // Handle this function when did't have permission
                const message = permission !== 'UPDATE' ? 'permission' : 'validation';
                this.addColumnErrorValidations(sheet, event.address, message, rowNumber, settings, failedValidationRows, columnLetter, headerItem?.name, true, failedValidationRowMap);
              }
              else {
                // Handle this function when single column changed
                if (inputStatus !== 'Deleted') {
                  // Handle this when failed rows match and column
                  let validationFailedRowByIndex = failedValidationRows?.errorRows?.findIndex((el: any) => el.row === rowNumber) ?? -1;
                  let columnRow = failedValidationRows?.errorRows?.find((el: any) => (el.row === rowNumber && el.column.includes(columnLetter)));
                  if (!!valueMatch && (validationFailedRowByIndex !== -1 && !!columnRow)) {
                    // Handle this when value match then remove that particular row and column
                    const item: any = this.updateSettings(sheet, settings, failedValidationRows, rowNumber, columnLetter, headerItem?.name, true, failedValidationRowMap);
                    validationFailedRowByIndex = item.errorRowByIndex;
                  } else if (!valueMatch || headerItem?.autoGenerated || headerItem?.permission !== 'UPDATE') {
                    const message = headerItem?.autoGenerated ? 'permission' : 'validation';
                    this.addColumnErrorValidations(sheet, event.address, message, rowNumber, settings, failedValidationRows, columnLetter, headerItem?.name, true, failedValidationRowMap);
                  }
                  if (validationFailedRowByIndex === -1 && valueMatch && !headerItem?.autoGenerated) {
                    // Handle this for remove current row color and message.
                    inputMessgeValue.values = [['']];
                    hasChangedRow = true;
                    const val = (inputStatus === 'New Row' || idColumnVal === '') ? [['New Row']] : [['Changed']];
                    inputValue.values = val;
                    inputValue.getUsedRange().format.font.color = "#000000";
                    // var range = sheet.getRange("A" + rowNumber + ":XFD" + rowNumber);
                    currentRange.format.fill.color = "#ffd3a9";
                  }
                };
              }
              if (this.disablePublishButton == true) {
                await this.addPublishStatus(context, false, false);
              }
              await context.sync();
            }
            this.reportValidationProgress(0, 1, 'Finalizing worksheet validation...', 'step');
            const columnERange = sheet.getRange(`E1:E${Math.max(rowCount, 1)}`);
            columnERange.format.load("wrapText");
            columnERange.format.wrapText = false;
            await context.sync();
            if (validationTotalRows > this.environment?.VALIDATIONPOPUPLENGTH) {
              this.reportValidationProgress(
                this.validationProgress.totalRecords,
                this.validationProgress.totalRecords,
                'Data validation completed.',
                this.validationProgress.unit
              );
            }
            changeDetectionEventInProgress = false;
            if (this.insertedRow.length == 1) {
              this.excelChangeEvent(this.insertedRow[0])
              this.insertedRow = [];
            }
            this.cd.detectChanges();
          }
          catch (err: any) {
            changeDetectionEventInProgress = false;
            console.log(err, 'changeevt')
            if (err instanceof OfficeExtension.Error) {
              console.log(
                'DebugInfo:',
                JSON.stringify(err.debugInfo, null, 2)
              );
            }
            if (err?.message?.includes('cell-editing mode') && !event._retried) {
              // Retry once after a short delay when user was in cell-edit mode
              event._retried = true;
              setTimeout(() => {
                this.excelChangeEvent(event);
              }, 500);
              return;
            }
          } finally {
            changeDetectionEventInProgress = false;
            context.runtime.enableEvents = true;
            await context.sync();
          }
          this.closeValidationProgress();
          return;
        });
      } catch (error: any) {
        changeDetectionEventInProgress = false;
        console.error("Excel change event error:", error?.message || error);
        if (error instanceof OfficeExtension.Error) {
          console.log(
            'DebugInfo:',
            JSON.stringify(error.debugInfo, null, 2)
          );
        }
        if (error?.message?.includes('cell-editing mode') && !event._retried) {
          // Retry once after a short delay when user was in cell-edit mode
          event._retried = true;
          setTimeout(() => {
            this.excelChangeEvent(event);
          }, 500);
        } else if (error?.message?.includes('lost focus') || error?.message?.includes('multiple workbooks')) {
          this.message = {
            message: 'Please switch back to this workbook and try editing again.',
            type: 'error'
          };
          this.cd.detectChanges();
          this.clearMessage();
        } else if (error?.code === 'ItemNotFound' || error?.message?.includes("doesn't exist")) {
          this.message = {
            message: 'The sheet or resource was removed. Please reload the data.',
            type: 'error'
          };
          this.cd.detectChanges();
          this.clearMessage();
        }
        if (error instanceof (window as any).OfficeExtension.Error) {
          console.log("Debug info: " + JSON.stringify(error.debugInfo));
        }
        this.closeValidationProgress();
      } finally {
        changeDetectionEventInProgress = false;
        this.closeValidationProgress();
        await this.restoreExcelChangeEvents();
      }
    }
  }

  findLargestColumnIndex(addresses: string): any {
    if (!addresses) return -1;

    let columns: string[] = [];

    // Split the addresses by comma for multiple ranges
    let addressArray = addresses.split(',');

    addressArray.forEach((address) => {
      // Split ranges by colon
      let parts = address.split(':');
      parts.forEach((part) => {
        // Extract the letter part of the cell reference
        let column = part.match(/[A-Za-z]+/)?.[0];
        if (column) {
          columns.push(column);
        }
      });
    });

    // Find and return the lexicographically largest column
    let largestColumn = columns.sort((a, b) => (a > b ? 1 : -1)).pop() || '';
    return this.columnIndexFromLetter(largestColumn)
  }

  async addPublishStatus(context: any, status: boolean, syncImmediately = true) {
    this.disablePublishButton = status;
    const settings = context.workbook.settings;
    settings.add(this.tableName + 'changes', status);
    if (syncImmediately) {
      await context.sync();
    }
    this.cd.detectChanges();
  }

  /**
   * Handle this for validate the values
   * @param headerItem any
   * @param item any
   * @param currentLookupData any
   * @returns 
   */
  private createLookupValidationIndex(lookupData: any[]): Map<any, Set<any>> {
    const lookupIndex = new Map<any, Set<any>>();
    for (const lookupItem of lookupData || []) {
      let names = lookupIndex.get(lookupItem?.key);
      if (!names) {
        names = new Set<any>();
        lookupIndex.set(lookupItem?.key, names);
      }
      names.add(lookupItem?.name);
    }
    return lookupIndex;
  }

  public matchColumnValuesWithValidation(headerItem: any, item: any, currentLookupData: any, currentRange?: any) {
    if (headerItem?.formType === 'LOOKUP' && headerItem?.totalElements < this.totalElementLimit) {
      // Lookup attribute validation
      if (item !== '') {
        // let val = (typeof item === 'string' && item?.includes('{'))
        //   ? item?.split(/[\{\}]/).filter((el: any) => el !== "")
        //   : item;
        // val = !Array.isArray(val) ? item : val[0];

        // const valueMatch = currentLookupData?.find((el: any) => !!el.code ? el.code === val : el.name === val);
        // return valueMatch;
        // Extract name and code from val
        const match = item.toString().match(/^([^{}]+)(?:\{([^{}]+)\})?$/);

        if (!match) {
          return false; // The value does not match the expected format
        }
        const extractedCode = match[1];
        const extractedName = match[2] ? match[2].toString() : null;

        if (currentLookupData instanceof Map) {
          const names = currentLookupData.get(extractedCode);
          return extractedName === null ? currentLookupData.has(extractedCode) : !!names?.has(extractedName);
        }

        // Retain support for callers that still provide the lookup array.
        return (currentLookupData || []).some((el: any) => {
          const isNameMatch = (extractedName === null) || (el.name === extractedName);
          const isCodeMatch = (el.key === extractedCode);
          return (extractedName === null && isCodeMatch) || (extractedName !== null && isNameMatch && isCodeMatch);
        });
      }
    }
    else if (headerItem?.formType === 'FREE_FORM') {
      // Number validation
      if (headerItem?.dataType === 'number' && item !== '') {
        const isNumber = typeof item;
        if (isNumber !== 'number') {
          return false;
        }
      }

      // Date validation
      if (headerItem?.dataType === 'date' && item !== '') {
        const isDate = this.validateDate(item, headerItem?.dateFormat, currentRange);
        return isDate;
      }
    }
    return true;
  }

  /**
   * Handle this for date validation
   * @param dateStr any
   * @param format string
   * @returns 
   */
  public validateDate(dateStr: any, format: string, _currentRange?: any) {
    // Helper function to validate the date pattern
    function isPatternValid(dateStr: string, pattern: RegExp): boolean {
      return pattern.test(dateStr);
    }

    // Define regex patterns for different formats
    const patterns: any = {
      'MM/DD/YYYY': /^(0[1-9]|1[0-2]|[1-9])\/(0[1-9]|[12][0-9]|3[01]|[1-9])\/\d{4}$/,
      'DD/MM/YYYY': /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2]|[1-9])\/\d{4}$/,
      'YYYY/MM/DD': /^\d{4}\/(0[1-9]|1[0-2]|[1-9])\/(0[1-9]|[12][0-9]|3[01]|[1-9])$/,
    };

    // Handle numeric inputs
    if (typeof dateStr === 'number') {
      const milliseconds = (dateStr - 25569) * 86400 * 1000;
      dateStr = moment(milliseconds).utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format(format);
    }

    // Determine the appropriate pattern based on the format
    const pattern = patterns[format];
    if (!pattern || !isPatternValid(dateStr, pattern)) {
      return false;
    }

    // Parse the date based on format
    let month, day, year;
    const parts = dateStr.split('/').map(Number);

    switch (format) {
      case 'MM/DD/YYYY':
        [month, day, year] = parts;
        break;
      case 'DD/MM/YYYY':
        [day, month, year] = parts;
        break;
      case 'YYYY/MM/DD':
        [year, month, day] = parts;
        break;
      default:
        return false;
    }

    // Validate the date object
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return false;
    }

    // Define the acceptable date range
    const startDate = new Date('1900-01-01');
    const endDate = new Date('9999-12-31');
    // !!currentRange ? currentRange.values = [[dateStr]] : '';

    return date >= startDate && date <= endDate;
  }

  /**
   * Handle this function for row permission and edit the columns
   * @param sheet any
   * @param address any
   * @param permissionMessage string
   * @param rowNumber any
   * @param columnIndex any
   * @param value any
   */
  public addColumnErrorValidations(sheet: any, address: any, type: string, rowNumber: any, settings: any, settingsErrorValue: any, columnLetter: any, headerName: string, addSettings: boolean, errorRowMap?: Map<any, any>, formatBatch?: ValidationFormatBatch) {
    if (formatBatch) {
      formatBatch.errorStatusRows.add(+rowNumber);
      formatBatch.invalidCellAddresses.add(address);
    } else {
      sheet.getRange(`D${rowNumber}`).format.font.color = '#FF0000';
      sheet.getRange(address).format.fill.color = '#ffcecb';
    }

    // Initialize errorRows if not already defined or if settingsErrorValue?.errorStatus is not an array
    let errorRows = Array.isArray(settingsErrorValue?.errorRows)
      ? settingsErrorValue.errorRows
      : [];
    let existingRow = errorRowMap?.get(rowNumber) ?? errorRows?.find((el: any) => el.row === rowNumber);
    const existingColmn = existingRow?.column?.filter((el: any) => el === columnLetter);

    // Check if rowNumber is already in errorRows
    if (errorRows.length === 0 || !existingRow) {
      // Add rowNumber to errorRows if it's not already present
      existingRow = { row: rowNumber, column: [columnLetter], columnName: [headerName], type: [type] };
      errorRows.push(existingRow);
      errorRowMap?.set(rowNumber, existingRow);
    }
    else if (existingRow && existingColmn.length === 0) {
      existingRow.column = [...existingRow.column, columnLetter];
      existingRow.columnName = [...existingRow.columnName, headerName];
      existingRow.type = [...existingRow.type, type];
    }
    errorRows = errorRows.length > 0 ? errorRows : rowNumber;
    const currentRow = errorRowMap?.get(rowNumber) ?? errorRows?.find((el: any) => el.row === rowNumber);
    const permissionMsg = '- This attribute is read only. You do not have permission to update this attribute';
    const validationMsg = '- This attribute is not valid.';
    const message = !!currentRow ? `${currentRow?.columnName?.map((colName: any, index: number) => (currentRow?.type[index] === 'permission') ? `${colName} ${permissionMsg}` : `${colName} ${validationMsg}`).join('\n')}` : "";
    if (addSettings) {
      const inputMessageRange = sheet.getRange(`E${rowNumber}`);
      inputMessageRange.values = [[message]];
      sheet.getRange(`D${rowNumber}`).values = [['Error']];
      this.queueValidationErrorSettings(settings, this.tableName, errorRows);
    }
    const result = { error: errorRows, message: message };
    return result;
  }


  columnIndexFromLetter(letter: string): number {
    letter = letter.toUpperCase();
    let index = 0;
    for (let i = 0; i < letter.length; i++) {
      index = index * 26 + (letter.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
    }
    return index;
  }
  async addToChangeColumn(existingValues: any, indices: any[], context: any, range: any, newOrDelete = false) {
    if (!newOrDelete) {
      existingValues.forEach((changes: any, index: number) => {
        let data: any = [];
        data = changes[0] == "" ? [] : JSON.parse(existingValues[index]);
        data.push(...indices)
        data = [...new Set(data)];
        existingValues[index] = [JSON.stringify(data)];
      });
      range.values = existingValues;
      await context.sync;
    }
  }
  public async logout() {
    await this.safeExcelRun(async (context: any) => {
      const settings = context.workbook.settings;
      settings.add('roles', this.roles)
    });
    this.broadcastChannelService.closeBroadcastChannel();
    localStorage.clear();
    this.route.navigate(['/landing']);
  }

  public onSavedFilter() {
    let dialog: any;
    this.previousQuery = this.query
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/savedFilter/${this.entity.id}`,
      { height: 80, width: 60 },
      (item) => {
        dialog = item.value;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            dialog.close();
            const res = arg?.message != 'close' && JSON.parse(decodeURIComponent(arg?.message));
            if (arg?.message != 'close' && res?.type !== 'invalid-version') {
              this.savedFilter = JSON.parse(decodeURIComponent(arg?.message));
              this.query = this.savedFilter.filterQuery;
              this.isUpdate = true;
              setTimeout(() => {
                this.openDialogBox(this.entity);
              }, 100);
            }

            if (res?.type === 'invalid-version') {
              dialog.close()
              setTimeout(() => {
                this.handleMismatchVersionDialog(res?.message);
              }, 500);
            }
          });
      });
  }

  /**
   * Handle this function for add and edit the particular settings
   * @param settings any
   * @param errorStatus any
   * @param rowNumber number
   * @returns 
   */
  updateSettings(sheet: any, settings: any, errorStatus: any, rowNumber: number, columnLetter: any, columnName: any, addSettings: boolean, errorRowMap?: Map<any, any>) {
    const inputMessageRange = sheet.getRange(`E${rowNumber}`);
    let existingRow = errorRowMap?.get(rowNumber) ?? errorStatus?.errorRows?.find((elm: any) => elm.row === rowNumber);
    const removeColumn = existingRow?.column?.filter((el: any) => el !== columnLetter);
    const removeColumnName = existingRow?.columnName?.filter((el: any) => el !== columnName);
    if (removeColumn.length > 0) {
      existingRow.column = removeColumn;
      existingRow.columnName = removeColumnName;
    }
    else {
      errorStatus.errorRows = errorStatus?.errorRows?.filter((el: any) => el.row !== rowNumber);
      errorRowMap?.delete(rowNumber);
    }
    // errorStatus.errorRows = errorStatus?.errorRows?.filter((el: any) => !(el.row === rowNumber && el.column === columnLetter));
    const errorRowByIndex = errorRowMap ? (errorRowMap.has(rowNumber) ? 0 : -1) : errorStatus?.errorRows?.findIndex((el: any) => el.row === rowNumber);
    const currentExistingRow = errorRowMap?.get(rowNumber) ?? errorStatus?.errorRows?.find((elm: any) => elm.row === rowNumber);
    const permissionMsg = '- This attribute is read only. You do not have permission to update this attribute';
    const validationMsg = '- This attribute is not valid.';
    const message = !!currentExistingRow ? `${currentExistingRow?.columnName?.map((colName: any, index: number) => (currentExistingRow?.type[index] === 'permission') ? `${colName} ${permissionMsg}` : `${colName} ${validationMsg}`).join('\n')}` : '';
    inputMessageRange.values = [[message]];
    const result = { errorRowByIndex: errorRowByIndex, errorStatus: errorStatus.errorRows }
    if (addSettings) {
      this.queueValidationErrorSettings(settings, this.tableName, errorStatus.errorRows);
    }
    return result;
  }

  async removeEventHandler() {
    await this.safeExcelRun(async (context: any) => {
      this.onChangedEventHandler.remove();
      await context.sync();
      this.onChangedEventHandler = null;
    });
  }

  async manageRowIdentifierRow(sheet?: Excel.Worksheet): Promise<void> {
    const columnName = '__ROW_IDENTIFIER';
    const startRowIndex = 1;
    const columnIndex = this.headers.findIndex((header: any) => header.name === columnName);

    if (columnIndex !== -1 && columnIndex < this.headers.length && this.headers[columnIndex].name === '__ROW_IDENTIFIER') {
      const formula = `=ROW()`;

      // Apply formula '=ROW()' to the column in the Excel sheet
      const columnRange = (sheet as any).getRangeByIndexes(startRowIndex, columnIndex, 1, 1);
      columnRange.formulas = [[formula]];
      columnRange.load(['formulas']);
    }
  }

  private async tryCatchWrapper(callback: Function, message?: string) {
    try {
      if (callback) {
        await callback();
      }
    } catch (e) {
      if (message) {
        console.log("indexDB error", e)
        console.error(message);
      }
    }
  }

  async onSubmit() {
    //   await Excel.run(async (context: any) => {
    //     context.workbook.close(Excel.CloseBehavior.skipSave);
    // });
    window.location.reload();
  }

  public handleOfflineDialog() {
    this.stopPublishNetworkMonitor();
    this.unsubscribeNetwork();
    this.contentName = '';
    this.indexeddbService.closeDb();
    this.cd.detectChanges();
    if (!!this.intervalId) {
      clearInterval(this.intervalId)
    }
    this.clearMessage();
    hasChangedRow = false;
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/missing/offline`,
      { height: 40, width: 40 },
      (item) => {
        const dialog = item.value;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            if (arg?.message == 'continue' && navigator.onLine) {
              dialog.close();
              setTimeout(() => {
                this.refreshEntityRecords();
              }, 500)
            }
          });
      });
  }

  openSettings() {
    Office.context.ui.displayDialogAsync(
      `${environment.URL}/#/settings`,
      { height: 60, width: 25 },
      (item) => {
        const dialog = item.value;
        dialog.addEventHandler(
          Office.EventType.DialogMessageReceived,
          async (arg: any) => {
            if (arg?.message === 'send') {
              const data = { globalSettings: this.globalSettings, currentEntity: this.entity };
              setTimeout(() => {
                dialog.messageChild(JSON.stringify(data));
              }, 400)
            }
            else {
              dialog.close();
              if (arg?.message !== 'close') {
                this.globalSettings = JSON.parse(arg.message);
                this.showSytsemAttribute = this.globalSettings.settingsData.showSystem;
                this.showOrHideSystemAtrributes();
              }
            }
          }
        )
      }
    )
  }

  async showOrHideSystemAtrributes() {
    await this.safeExcelRun(async (context: any) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      const headers = this.currentSheetHeaders ? this.currentSheetHeaders : this.headers;
      headers?.forEach((item: any, index: any) => {
        const columnLetter = ExcelHelper.getColumnLetter(index);
        const normalizedHeaderName = String(item?.name || item?.selectColumn || item?.column || '')
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '');
        const isAlwaysVisibleAuditHeader = ['createdon', 'updatedon', 'lastupdatedon'].includes(normalizedHeaderName);
        if (!!columnLetter && item.systemAttribute && item.showInForm && item.name !== 'id' && !isAlwaysVisibleAuditHeader) {
          sheet.getRange(`${columnLetter}:${columnLetter}`).columnHidden = !this.showSytsemAttribute;
        }
      });
      await context.sync();
    });
  }
}
class ExcelHelper {
  static getColumnLetter(columnIndex: number): string {
    let dividend = columnIndex + 1;
    let columnName = '';
    let modulo;

    while (dividend > 0) {
      modulo = (dividend - 1) % 26;
      columnName = String.fromCharCode(65 + modulo) + columnName;
      dividend = Math.floor((dividend - modulo) / 26);
    }

    return columnName;
  }
}

// Handle this function for getting the column range
function extractColumnsFromRange(range: any) {
  // Regular expression to match the start and end of the range
  const rangeRegex = /([A-Z]+)(\d+):([A-Z]+)(\d+)/;

  // Match the range string against the regex
  const match = range.match(rangeRegex);

  if (match) {
    // Extract start and end columns and rows from the regex match
    const startColumn = match[1];
    const endColumn = match[3];
    // Function to convert column letters to a number
    function columnToNumber(col: any) {
      let num = 0;
      for (let i = 0; i < col.length; i++) {
        num = num * 26 + (col.charCodeAt(i) - 'A'.charCodeAt(0) + 1);
      }
      return num;
    }

    // Function to convert a number to column letters
    function numberToColumn(num: any) {
      let col = '';
      while (num > 0) {
        num--;
        col = String.fromCharCode(num % 26 + 'A'.charCodeAt(0)) + col;
        num = Math.floor(num / 26);
      }
      return col;
    }

    // Get the numeric values of the start and end columns
    const startColNum = columnToNumber(startColumn);
    const endColNum = columnToNumber(endColumn);

    // Create an array of columns in the range
    const columnsInRange = [];
    for (let colNum = startColNum; colNum <= endColNum; colNum++) {
      columnsInRange.push(numberToColumn(colNum));
    }

    return columnsInRange;
  } else {
    throw new Error('Invalid range format');
  }
}

function generateRange(start: any, end: any) {
  const range = [];
  for (let i = start; i <= end; i++) {
    range.push(i);
  }
  return range;
}

function parseRowNumbers(address: any) {
  // Extract the numeric part(s) from the address using regex
  const matches = address.match(/\d+/g);

  if (!matches) {
    return null; // Handle cases where no numeric part is found
  }

  // Parse the numeric part(s) into integers
  const rowNumbers = matches.map((num: any) => parseInt(num));

  // If there's only one number, duplicate it to create [num, num]
  if (rowNumbers.length === 1) {
    return [rowNumbers[0], rowNumbers[0]];
  } else if (rowNumbers.length === 2) {
    // Ensure the first number is less than or equal to the second number
    return [Math.min(rowNumbers[0], rowNumbers[1]), Math.max(rowNumbers[0], rowNumbers[1])];
  } else {
    return null; // Handle unexpected cases where more than two numbers are found
  }
}

function areRowsSequential(arr: string[]): boolean {
  if (arr.length === 1) {
    return true; // Single cell is considered sequential
  }
  // Extract and sort row numbers from cell references
  let rowNumbers = arr.map((cell: any) => parseInt(cell.match(/\d+/)[0])).sort((a, b) => a - b);

  // Check if row numbers are sequential
  for (let i = 1; i < rowNumbers.length; i++) {
    if (rowNumbers[i] !== rowNumbers[i - 1] + 1) {
      return false;
    }
  }
  return true;
}

function convertCellsToRange(cellList: any, rowSequential: boolean) {
  // Split the input string into an array of cell references
  let cells = cellList.split(',');

  // Initialize variables to find min and max row numbers and column letters
  let minRow = Number.MAX_SAFE_INTEGER;
  let maxRow = 0;
  let startColumn = '';
  let endColumn = '';

  // Iterate through each cell reference
  if (cells.length > 1 && rowSequential) {
    cells.forEach((cell: any) => {
      // Extract row number and column letter from the cell reference
      let match = cell.match(/([A-Z]+)(\d+)/);
      if (match) {
        let colLetter = match[1];
        let rowNumber = parseInt(match[2]);

        // Determine the minimum and maximum row numbers
        if (rowNumber < minRow) {
          minRow = rowNumber;
        }
        if (rowNumber > maxRow) {
          maxRow = rowNumber;
        }

        // Take the column letter (assuming all cells are in the same column)
        if (startColumn === '') {
          startColumn = colLetter;
        }
        // Always update the endColumn to ensure the last column is taken
        endColumn = colLetter;
      }
    });

    // Construct the range string
    let range = startColumn + minRow + ':' + endColumn + maxRow;
    return range;
  } else {
    return cells
  }
}
